import {
  AfterViewChecked,
  ChangeDetectorRef,
  Component,
  effect,
  ElementRef,
  EventEmitter,
  HostBinding,
  HostListener,
  inject,
  Inject,
  Input,
  input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  Renderer2,
  SimpleChanges,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { DateRange, MatDatepicker } from '@angular/material/datepicker';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LocalStorageService } from '../../services/local.storage.service';
import { VisitorService } from '../../services/visitor.service';
import { BaseComponent } from 'src/app/common/components/base.component';
import { ActivatedRoute } from '@angular/router';
import { clone, isEmptyArray, isNullOrUndefined } from 'src/app/common/utils/object.extensions';
import { ScriptService } from 'src/app/common/services/load.script/load.script.service';
import { ImageComponent } from 'src/app/common/components/image/image.component';
import { AccordionComponent } from 'src/app/common/components/accordion/accordion.component';
import { DateRangePickerComponent } from 'src/app/common/components/date.range.picker/date.range.picker.component';
import { MsgBoxComponent } from '../im.messager/msg.box/msg.box.component';
import { GoogleMapComponent } from '../google.map/google.map.component';
import { SocialLoginComponent } from '../social.login/social.login.component';
import { LoadingDotComponent } from 'src/app/common/components/loading.dot/loading.dot.component';
import { TripEditorComponent } from '../trip.editor/trip.editor.component';
import { PlaceServicesDisplayComponent } from '../place.services.display/place.services.display.component';
import { ClickStopPropagationDirective } from 'src/app/common/directive/click.stop.propagation.directive';
import { catchError, debounceTime, fromEvent, of, tap, timer } from 'rxjs';
import { VisitorPlace } from '../../models/visitor.place';
import { VisitorEvent } from '../../models/visitor.event';
// REMOVED: ILinkPreview import - no longer needed for old embedded content logic
import { AIModel, IAIResponse, ITravelAssistantMessage } from '../../models/travel.assistant';
import { MatSnackBar, MatSnackBarRef, TextOnlySnackBar } from '@angular/material/snack-bar';
import { TravelBuddySettings } from '../../models/travel.buddy.settings';
import {
  AsyncPipe,
  CommonModule,
  DatePipe,
  DOCUMENT,
  Location,
  NgClass,
  NgForOf,
  NgIf,
  NgStyle,
  SlicePipe,
} from '@angular/common';
import { finalize, switchMap, takeUntil, timestamp } from 'rxjs/operators';
import { IMapMarkerWithCustomData } from '../../models/place.marker';
import { Store, select } from '@ngrx/store';
import { IAppState, IFrontendSettings } from '../../ngrx.stores/frontend.settings/states';
import { frontendSettingsSelector } from '../../ngrx.stores/frontend.settings/selectors';
import { Observable, Subscription } from 'rxjs';
import { CheckLoginStatusService } from '../social.login/checkLoginStatus.service';
import { ModalService } from 'src/app/common/services/modal/modal.service';
import { FancyPlaceDetailsModalComponent } from 'src/app/modules/place-calendar/components/place.details.modal/fancy.place.details.modal/fancy.place.details.modal.component';
import { FancyEventDetailsModalComponent } from 'src/app/modules/event-calendar/components/event.details.modal/fancy.event.details.modal/fancy.event.details.modal.component';
import { IPlaceDetailsModalData } from 'src/app/modules/place-calendar/components/place.details.modal/place.details.modal.provider';
import { IEventDetailsModalData } from 'src/app/modules/event-calendar/components/event.details.modal/event.details.modal.provider';
import { TravelBuddyChatService } from '../../services/travelbuddy.chat.service';
import { GuestChatStorageService } from '../../services/guest.chat.storage.service';
import {
  ConfirmModalComponent,
  ConfirmModalData,
  ConfirmModalActions,
} from '../confirm.modal/confirm.modal.component';
import { ButtonTriggerEvent } from 'src/app/common/components/button/button.component';
import { ConfigService } from 'src/app/common/services/config/config.service';
import { VisitorPlaceService } from 'src/app/modules/event-calendar/services/visitor.place.service';
import { removeHtmlTags } from 'src/app/common/utils/string.extensions';
import { EventTimeService } from 'src/app/modules/event-calendar/services/event.time.service';
import { MatMenuTrigger } from '@angular/material/menu';
import { MediaQueryService } from 'src/app/common/services/media.query/media.query.service';
import { guid } from 'src/app/common/utils/guid';
import { TravelMode } from '../../services/google.map.service';
import { TripStorageCommand } from '../../models/vititor.trip.storage.command';
import { SharedModule } from '../../shared.module';
import { SsrDetailNavigationService } from '../../services/ssr.detail.navigation.service';
import { SUN_EDITOR_CSS_URL } from 'src/app/common/constants/sun.editor';

// Custom date format for MM/DD/YYYY
export const MY_DATE_FORMATS = {
  parse: {
    dateInput: 'MM/DD/YYYY',
  },
  display: {
    dateInput: 'MM/DD/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'ig-im-message-box',
  standalone: true,
  imports: [
    // Angular Core
    NgIf,
    NgForOf,
    AsyncPipe,
    DatePipe,
    NgStyle,
    NgClass,

    // Forms
    FormsModule,
    ReactiveFormsModule,

    CommonModule,
    SharedModule,

    TripEditorComponent,
    PlaceServicesDisplayComponent,

    // Angular Material
    MatIconModule,
    MatInputModule,
    MatMenuModule,
    MatFormFieldModule,
    MatSelectModule,
    MatSnackBarModule,
    MatExpansionModule,
    MatCheckboxModule,
    MatTooltipModule,
    MatButtonModule,
    MatDatepickerModule,
    MatNativeDateModule,
    // Custom Pipes
    SlicePipe,
  ],
  templateUrl: './im.message.box.component.html',
  styleUrls: ['./im.message.box.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [{ provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS }],
})
export class ImMessageBoxComponent extends BaseComponent implements OnInit, OnChanges, OnDestroy {
  // Retry controls for AI responses
  private maxRetries = 3;
  private retryCount = 0;
  maxSavedAITrips = 10;
  @HostBinding('class') hostClass = 'ig-im';

  isUseWelcomeLandscreen: boolean = true;
  welcomePageMapMarkers = [];
  welcomePagePlaces: string[] = [
    'Forsyth Park',
    'Savannah Historic District',
    'The Cathedral Basilica of St. John the Baptist',
    // 'Wormsloe State Historic Site',
    'Marriott Savannah Riverfront',
    'Hyatt Regency Savannah',
    'River Street Inn',
  ];
  @ViewChild(GoogleMapComponent, { static: false })
  googleMap: GoogleMapComponent;
  @ViewChild('placesScrollContainer', { static: false })
  placesScrollContainer: ElementRef<HTMLDivElement>;
  @ViewChild('favList', { static: false }) favList: ElementRef<HTMLDivElement>;
  @ViewChild('aiTripList', { static: false }) aiTripList: ElementRef<HTMLDivElement>;
  @ViewChild('expandBtn', { static: false })
  expandBtn: ElementRef<HTMLButtonElement>;
  @ViewChild('chatInput', { static: false }) chatInput?: ElementRef<HTMLTextAreaElement>;
  @ViewChild('loginDialog', { static: false }) loginDialog?: ElementRef<HTMLElement>;
  @ViewChild('sharedTripDialog', { static: false }) sharedTripDialog?: ElementRef<HTMLElement>;
  @Input() answerProcessor: (data: IAIResponse) => IAIResponse;

  right = input<string>();
  left = input<string>();
  bottom = input<string>();
  top = input<string>();
  isShowCloseBtns = input<boolean>();
  containerMode = input<string>();

  chatRight: string;
  chatLeft: string;
  chatTop: string;
  chatBottom: string;
  isChatAreaDown: boolean = false;

  // indicatorRight: string;
  // indicatorLeft: string;
  // indicatorTop: string;
  isIndicatorShowedPageLevel = false;
  indicatorBottom: string;
  private lastChatTriggerElement: HTMLElement | null = null;
  private lastLoginTriggerElement: HTMLElement | null = null;
  private lastSharedTripTriggerElement: HTMLElement | null = null;
  private readonly focusableSelector = [
    'button:not([disabled])',
    '[href]',
    'input:not([disabled])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    '[role="button"][tabindex]:not([tabindex="-1"])',
    '[role="tab"][tabindex]:not([tabindex="-1"])',
    '[tabindex]:not([tabindex="-1"])',
  ].join(', ');

  /** control the display of the entire chat popup */
  isShow = false;
  isScreenExpanded = false;

  /* isShowLandscreen = true means in the first indication page of the AI chat feature */
  isShowLandscreen = true;
  hasChatViewShowed = false;
  isAskingAfterLogin = false;
  isWaitingForAIResponse = false;
  loadingTips = [
    'Let me think about this!',
    'Let me select the best idea!',
    'On my way!',
    "Hold on tight, we're speeding up!",
    'Making the digital world spin!',
    'Almost there, hang on!',
    'Loading your future experience!',
    "Hold tight, we're about to launch!",
  ];

  // need to specify these Tailwind classes to make sure they are bundled in the final CSS
  style = 'h-[700px] w-[640px] w-[400px] h-[300px]';
  form: FormGroup;
  msg: string;
  assistantId: string;
  threadId: string;
  customProcessor: (data: IAIResponse) => IAIResponse = null;
  @Input() aiModel: AIModel = 'chatgpt-then-google';
  @Input() public target = '';
  @Input() public place: VisitorPlace;
  /* the content in the landing page is showing up one by one */
  @Input() public showLandscreenContent: boolean[] = [];
  @Input() public travelBuddySettings: TravelBuddySettings;

  @Input() public allPlaces: VisitorPlace[] = [];
  @Input() public allEvents: VisitorEvent[] = [];
  allFeaturedPlaces: VisitorPlace[] = [];

  // Frontend settings for logo
  frontendSettings$: Observable<IFrontendSettings | null>;

  // Matched real places and events from AI response
  matchedPlaces: VisitorPlace[] = [];
  matchedEvents: VisitorEvent[] = [];

  // Selected place/event for details panel
  selectedPlaceOrEvent: VisitorPlace | VisitorEvent | null = null;
  nearbyPlaces: VisitorPlace[] = [];
  private nearbyPlacesCache = new Map<string, VisitorPlace[]>();
  isDetailsOpen = false;
  isLoadingDetails = false;
  isLoadingNearbyPlaces = false;
  isShowFeaturedPlaces = true;

  @Output() onSendClick: EventEmitter<string> = new EventEmitter();
  @Output() onTryAgain: EventEmitter<string> = new EventEmitter();
  @Output() onMsgCreated: EventEmitter<any> = new EventEmitter();
  @Output() onExpandScreen: EventEmitter<boolean> = new EventEmitter();
  @Output() userChatHistoryReady: EventEmitter<boolean> = new EventEmitter();
  isUserChatHistoryReady = false;
  isLoadingUserChatHistory = false;

  msgHistory: ITravelAssistantMessage[]; // for displaying on the html
  userChatHistory: any[] = []; // load from DB
  hasScrollbar = false;
  isMappingData = false;

  streamWordCount = 0;
  aiResTextContent = '';
  private streamingUserIdentity: string | undefined = undefined;

  /*
    when you first in the landing page of the AI chat popup, and click on any question to jump to chatting section,
    the top bannder section will be folded after AI has responded
  */
  isAIRespond = false;
  isFolding = false;
  /*
    when you first in the landing page of the AI chat popup, and click on any question to jump to chatting section,
    the top bannder section will be folded, and after the folding completed, isInNormalChat will be set to true
  */
  isInNormalChat = false;
  // REMOVED: fallbackLinkPreviewData - no longer needed for old embedded content logic
  isAtbottom = false;

  isFirstTime = false;
  isForDestination = false;

  isShowLogin = false;
  isAppendLoginToChatArea = false;
  isAnonymous = false;
  private isTransferringGuestChats = false;
  anonymousUserId: string | undefined = undefined;
  userEmail: string | undefined = undefined;
  emailErrorMsg = '';

  userProfilePicture: string | undefined = undefined;

  // New properties for login popup
  isShowLoginPopup = false;
  emailInput = '';
  isAllowTrackingChat = true; // currently removed the checkbox for asking for user permission, so we will track the conversations for all users
  isShowUpdateChatTitle = true;
  private pendingTripCopyAfterLogin: any | null = null;

  // Subscription for login status changes
  private loginStatusSubscription: Subscription;
  private offlineSubscription?: Subscription;
  private onlineSubscription?: Subscription;
  private offlineSnackBarRef?: MatSnackBarRef<TextOnlySnackBar>;
  private activeSseSubscription?: Subscription;
  private activeStreamToken: string | null = null;
  private chatIdAliases = new Map<string, string>();
  private suggestedPromptsByChatId = new Map<string, string[]>();
  private pendingStreamByChatId = new Map<
    string,
    {
      fullResponse: string;
      hasMetadata: boolean;
      hasToolCall: boolean;
    }
  >();

  // New UI properties
  userChatFolders: { _id: string; name: string; chats: any[] }[] = [];
  selectedFolder: any;
  selectedFolderId: string | null = null;
  // Add this to your component class
  currentChatIndex: number | null = null;
  currentChat: any;
  currentFolderName = '';
  newFolderName = '';
  deletingChatId: string;
  isDeleting = false;
  recentChats: Array<{
    id: string;
    title: string;
    messages: any[];
    timestamp: Date;
    pinned?: boolean;
    pinnedAt?: string;
    metadata?: any;
    folderId?: string;
    rawCreatedAt?: string;
  }> = [];
  currentMsgForMap: ITravelAssistantMessage | null = null;

  suggestedPrompts: string[] = [];

  defaultAvatar =
    'https://iti-images.s3.amazonaws.com/events/46a894bb-0ef0-270c-7118-e3bacdad1c9a.webp';

  // Desktop sidebar collapse state
  isSidebarCollapsed = true;
  // For guest users, auto-open sidebar only once after their first question.
  private hasAutoOpenedSidebarForGuest = false;

  // Tracks IDs of chats that were just transferred from a guest session,
  // used to show a brief highlight animation before reverting to normal styling.
  newlyTransferredChatIds = new Set<string>();
  private guestTransferStartTime = 0;
  private chatHistoryLoadId = 0;

  // Recent chats state
  isRecentChatsExpanded = true;
  hasSharedTripInUrl = false;
  sharedTripLink = '';
  isShowSharedTripPrompt = false;
  sharedUserTripId = '';
  sharedSingleTripId = '';
  isLoadingSharedTrip = false;
  isSharedTripModalOpen = false;
  sharedTripModalTrip: any = null;
  canEditTrip = false;

  // Map panel state (desktop only)
  isMapOpen = false;

  // Places scroll navigation state
  canScrollLeft = false;
  canScrollRight = false;

  // Route drawing state
  directionType: 'normal' | 'optimized' | undefined = undefined;
  directionLocations: {
    id: string;
    name: string;
    address: string | any;
    lat: number;
    lng: number;
    stopover: boolean;
  }[] = [];

  // Check if current message is an itinerary response
  get isCurrentItineraryResponse(): boolean {
    if (!this.msgHistory || this.msgHistory.length === 0) return false;

    const latestAIMessage = this.msgHistory
      .slice()
      .reverse()
      .find((msg) => msg.type === 'AI');

    return latestAIMessage?.askForItinerary === true;
  }

  // Check if mobile
  get isMobile(): boolean {
    return window.innerWidth <= 1080;
  }

  // Current chat info for header
  currentChatTitle: string = '';
  currentChatDate: Date = new Date();

  // Trip planning properties
  selectedDate: Date | null = null;
  selectedDateRange: { start: Date; end: Date } | null = null;
  minDate: Date = new Date();
  maxDate: Date = new Date(2030, 11, 31);
  selectedPreferences: string[] = [];
  tripPreferences: any[] = [];
  suggestedQuestions: any[] = [];
  isFlexibleDates = true;

  errorMsgs = [
    `Looks like you've asked a question that's above my pay grade—err. Got another question to throw my way? `,
    `To err is human, to forgive divine, but for your AI Travel Buddy, it's downright awkward! Got another zinger for me? `,
    `Wow, you've managed to stump your AI buddy. You just won a million dollars! Just kidding. Got another question to throw my way? `,
    `You've found a gap in my digital wisdom! Mind tossing another question my way? `,
  ];

  @ViewChild('dateRangePicker', { static: false }) dateRangePicker: DateRangePickerComponent;
  @ViewChild('container', { static: true }) container: ElementRef;
  @ViewChild('chatContainer', { static: false }) chatContainer: ElementRef;
  @ViewChild('detailsPanel', { static: false }) detailsPanel: ElementRef;
  @ViewChild('allowTrackingCbox', { static: false })
  allowTrackingCbox: ElementRef;
  @ViewChild('socialLogin', { static: false })
  socialLogin: SocialLoginComponent;

  @ViewChild('googleLogin', { static: false })
  googleLogin: any;

  @ViewChild('googlePopupContainer', { static: false })
  googlePopupContainer: ElementRef<HTMLElement>;

  @ViewChild('facebookLogin', { static: false })
  facebookLogin: any;

  placeService = inject(VisitorPlaceService);
  eventTimeService = inject(EventTimeService);
  mediaQueryService = inject(MediaQueryService);

  isCheckPlaceStatusInAdvance = true;

  savedAITrips: TripStorageCommand;

  constructor(
    public activatedRoute: ActivatedRoute,
    public cdRef: ChangeDetectorRef,
    private _fb: FormBuilder,
    private _localStorage: LocalStorageService,
    private _visitorService: VisitorService,
    private _snackBar: MatSnackBar,
    private _scriptService: ScriptService,
    private _renderer: Renderer2,
    @Inject(DOCUMENT) private _document: Document,
    private _store: Store<IAppState>,
    private checkLoginStatusService: CheckLoginStatusService,
    private _modalService: ModalService,
    private travelBuddyChatService: TravelBuddyChatService,
    private location: Location,
    private guestChatStorage: GuestChatStorageService,
    private ssrDetailNavigationService: SsrDetailNavigationService,
  ) {
    super({ activatedRoute });

    // Initialize frontend settings
    this.frontendSettings$ = this._store.pipe(select(frontendSettingsSelector));

    this.form = this._fb.group({
      msg: [null, [Validators.required]],
      email: [null, []],
    });

    // this.resetStepShowing();

    effect(() => {
      // will be called when `right or bottom` is initialized or changes.
      console.log('right', this.right());
      console.log('bottom', this.bottom());
      console.log('left', this.left());
      console.log('top', this.top());

      this.getChatBoxPosition();
      this.getIndicatorPosition();
    });

    this.mediaQueryService.resized.subscribe(() => {
      this.getChatBoxPosition();
      this.getIndicatorPosition();
    });
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['allPlaces'] && this.allPlaces) {
      console.log('allPlaces changed, count:', this.allPlaces.length);
      // this.updateWelcomePageMarkers();

      // TEMPORARY: staging server is missing the isChoice field sometimes, so we added a fallback to fetch featured places if no place is marked as choice
      if (this.allPlaces.length) {
        const hasFeatured = this.allPlaces.some((place) => place.isChoice);
        if (!hasFeatured) {
          this.placeService.getAllApprovedFeaturedPlaces(this.hubName).subscribe((places) => {
            this.allFeaturedPlaces = places;
          });
        }
      }
    }
  }

  override ngOnDestroy(): void {
    // Clean up subscription to prevent memory leaks
    this.dismissOfflineSnackBar();
    if (this.loginStatusSubscription) {
      this.loginStatusSubscription.unsubscribe();
    }
    if (this.offlineSubscription) {
      this.offlineSubscription.unsubscribe();
    }
    if (this.onlineSubscription) {
      this.onlineSubscription.unsubscribe();
    }
    if (this.activeSseSubscription) {
      this.activeSseSubscription.unsubscribe();
    }
  }

  getandomErrorMsg() {
    return this.errorMsgs[Math.floor(Math.random() * this.errorMsgs.length)];
  }

  getPlacesForLandingPage(limit = 14): VisitorPlace[] {
    const allPlaces = this.allPlaces ?? [];
    const allFeaturedPlaces = this.allFeaturedPlaces ?? [];

    let featured = allFeaturedPlaces.length
      ? [...allFeaturedPlaces]
      : allPlaces
          .filter(
            (place) =>
              place.isChoice &&
              place.isApproved &&
              !place.business_status?.toLowerCase().includes('closed'),
          )
          .sort((a, b) => (b.rating || 0) - (a.rating || 0))
          .slice(0, limit);

    if (featured.length < limit) {
      featured = [
        ...featured,
        ...allPlaces
          .filter(
            (place) =>
              !place.isChoice &&
              place.isApproved &&
              !place.business_status?.toLowerCase().includes('closed'),
          )
          .sort((a, b) => (b.rating || 0) - (a.rating || 0))
          .slice(0, limit),
      ];
    }
    featured = featured.slice(0, limit);
    return featured;
  }

  private updateWelcomePageMarkers(): void {
    if (!this.allPlaces) return;

    // Process immediately
    this.welcomePageMapMarkers = [];
    for (const item of this.allPlaces.filter((item) =>
      this.welcomePagePlaces.includes(item.name),
    )) {
      console.log('--- welcomePageMapMarkers 3');
      this.welcomePageMapMarkers.push({
        position: new google.maps.LatLng(
          item.lat || item.address?.lat,
          item.lng || item.address?.lng,
        ),
        label: {
          text: '🏛 ' + item.name,
          fontWeight: 'normal',
          className:
            'bg-white text-black px-2 py-1 border border-black rounded shadow-lg -translate-y-6 z-0 relative',
        },
        title: item['feedId'] || item._id,
        data: item,
      } as IMapMarkerWithCustomData<VisitorPlace>);
    }

    // Use requestAnimationFrame for map bounds
    requestAnimationFrame(() => {
      this.googleMap?.fitBounds();
    });
  }

  ngOnInit() {
    const SCRIPT_PATH = `https://cdn.jsdelivr.net/npm/marked/marked.min.js`;

    if (!this._scriptService.isScriptExist(SCRIPT_PATH)) {
      const scriptElement = this._scriptService.loadJsScript(this._renderer, SCRIPT_PATH);
      scriptElement.onload = () => {
        console.log('markdown script loaded');
      };
      scriptElement.onerror = () => {
        console.log('Could not load the script: ' + SCRIPT_PATH);
      };
    }

    if (this.isMobile) {
      this.isSidebarCollapsed = true;
    }

    // Check URL parameter for AI Travel Planner and show the chat box if it is true
    const url = new URL(window.location.href);
    const showAiTravelPlanner = url.searchParams.get('show-ai-travel-planner');
    if (showAiTravelPlanner === 'true' && !this.isShow) {
      this.show();
    }

    const sharedUserTripId = url.searchParams.get('user-trip');
    const sharedSingleTripId = url.searchParams.get('single-trip');
    if (sharedUserTripId && sharedSingleTripId) {
      this.hasSharedTripInUrl = true;
      this.sharedTripLink = url.toString();
      this.isShowSharedTripPrompt = true;
      this.sharedUserTripId = sharedUserTripId;
      this.sharedSingleTripId = sharedSingleTripId;
    }

    // Load SunEditor CSS for fancy details component descriptions
    if (!this._scriptService.isScriptExist(SUN_EDITOR_CSS_URL)) {
      const linkElement = this._document.createElement('link');
      linkElement.rel = 'stylesheet';
      linkElement.href = SUN_EDITOR_CSS_URL;
      this._document.head.appendChild(linkElement);
    }

    // Check if user is already logged in from localStorage
    const storedEmail = this._localStorage.getItem('travelbuddy_user_email');
    const googleUser = this._localStorage.getItem('social.login.googleUser');
    const facebookUser = this._localStorage.getItem('social.login.facebookUser');

    this.userEmail = (storedEmail as string) || undefined;

    if (storedEmail || googleUser || facebookUser) {
      // User is logged in - will load their chats from API
      this.isAnonymous = false;
      console.log('%c this.isAnonymous', 'color: red', this.isAnonymous);
      this.loadRecentChatsFromStorage();
    } else {
      // Guest user - load chats from localStorage (no backend persistence)
      this.isAnonymous = true;
      console.log('%c this.isAnonymous', 'color: red', this.isAnonymous);
      this.loadRecentChatsFromStorage();
    }

    // Check if user is already logged in and update UI
    this.checkAndUpdateUserStatus();

    // Pre-load Google login library for better performance
    this.checkLoginStatusService.loadGoogleLibrary().catch((error) => {
      console.warn('Failed to pre-load Google library:', error);
    });

    // Subscribe to login status changes to close popup when login is successful
    this.loginStatusSubscription = SocialLoginComponent.loginStatus$.subscribe((status) => {
      if (status && this.isShowLoginPopup) {
        console.log('---------------------- Login status changed to true, closing popup');
        this.closeLoginPopup();
      }
    });

    this.initializeTripPlanning();
    this.setupNetworkStatusListeners();
  }

  private setupNetworkStatusListeners(): void {
    if (typeof window === 'undefined') return;

    this.offlineSubscription = fromEvent(window, 'offline').subscribe(() => {
      this.showOfflineSnackBar('No internet connection. Some features may not work.');
    });

    this.onlineSubscription = fromEvent(window, 'online').subscribe(() => {
      this.dismissOfflineSnackBar();
      this._snackBar.open('Internet connection restored.', 'Close', {
        duration: 3000,
        verticalPosition: 'top',
        panelClass: ['success-snackbar'],
      });
    });

    // If the page initializes while offline, show an immediate hint.
    if (!navigator.onLine) {
      this.showOfflineSnackBar('You are currently offline.');
    }
  }

  private showOfflineSnackBar(message: string): void {
    if (this.offlineSnackBarRef) return;

    this.offlineSnackBarRef = this._snackBar.open(message, 'Close', {
      verticalPosition: 'top',
      panelClass: ['warning-snackbar'],
    });

    this.offlineSnackBarRef.afterDismissed().subscribe(() => {
      this.offlineSnackBarRef = undefined;
    });
  }

  private dismissOfflineSnackBar(): void {
    this.offlineSnackBarRef?.dismiss();
    this.offlineSnackBarRef = undefined;
  }

  private initializeTripPlanning() {
    // Initialize with default values if not provided by settings
    if (this.travelBuddySettings?.ui?.tripPlanning) {
      this.tripPreferences = this.getDefaultPreferences();
      if (this.travelBuddySettings.ui.tripPlanning.preferences?.length) {
        this.tripPreferences = clone(this.travelBuddySettings.ui.tripPlanning.preferences);
      }

      // Priority 1: Use default questions from ui.questions (configured in dashboard)
      if (
        this.travelBuddySettings.ui.questions &&
        Array.isArray(this.travelBuddySettings.ui.questions) &&
        this.travelBuddySettings.ui.questions.length > 0
      ) {
        // Convert string array to SuggestedQuestion format
        this.suggestedQuestions = this.travelBuddySettings.ui.questions
          .filter((q) => q && q.trim().length > 0)
          .map((questionText, index) => ({
            id: `default_${index}`,
            text: questionText,
            highlighted: false, //index === 0, // Highlight the first question
            tags: ['default'],
          }));
      }
      // Priority 2: Use fallback defaults
      else {
        this.suggestedQuestions = this.getDefaultQuestions();
      }
    } else {
      this.tripPreferences = this.getDefaultPreferences();

      // Check for default questions in ui.questions even if tripPlanning is not set
      if (
        this.travelBuddySettings?.ui?.questions &&
        Array.isArray(this.travelBuddySettings.ui.questions) &&
        this.travelBuddySettings.ui.questions.length > 0
      ) {
        this.suggestedQuestions = this.travelBuddySettings.ui.questions
          .filter((q) => q && q.trim().length > 0)
          .map((questionText, index) => ({
            id: `default_${index}`,
            text: questionText,
            highlighted: false,
            tags: ['default'],
          }));
      } else {
        this.suggestedQuestions = this.getDefaultQuestions();
      }
    }

    // Set default selected preferences
    this.selectedPreferences = this.tripPreferences
      .filter((pref) => pref.selected)
      .map((pref) => pref.id);
  }

  private getDefaultPreferences() {
    return [];
    // const cityName = this.travelBuddySettings?.cityName || 'this destination';
    // return [
    //   {
    //     id: 'family',
    //     name: 'Traveling with Family',
    //     selected: false,
    //     category: 'traveler_type',
    //     enabled: true,
    //   },
    //   {
    //     id: 'couples',
    //     name: 'Perfect for Couples',
    //     selected: false,
    //     category: 'traveler_type',
    //     enabled: true,
    //   },
    //   {
    //     id: 'pet_friendly',
    //     name: 'Pet-Friendly Options',
    //     selected: false,
    //     category: 'accommodation',
    //     enabled: true,
    //   },
    //   {
    //     id: 'budget',
    //     name: 'Budget-Friendly',
    //     selected: false,
    //     category: 'price_range',
    //     enabled: true,
    //   },
    //   {
    //     id: 'luxury',
    //     name: 'Luxury Experience',
    //     selected: false,
    //     category: 'price_range',
    //     enabled: true,
    //   },
    //   {
    //     id: 'outdoor',
    //     name: 'Outdoor Activities',
    //     selected: false,
    //     category: 'activity_type',
    //     enabled: true,
    //   },
    //   {
    //     id: 'cultural',
    //     name: 'Cultural Experiences',
    //     selected: false,
    //     category: 'activity_type',
    //     enabled: true,
    //   },
    // ];
  }

  private getDefaultQuestions() {
    const cityName = this.travelBuddySettings?.cityName || 'this destination';
    return [
      {
        id: 'itinerary',
        text: `Suggest a 2-day itinerary in ${cityName}.`,
        highlighted: false,
        tags: ['itinerary', 'planning'],
      },
      {
        id: 'hotels',
        text: `What are the best hotels in ${cityName}?`,
        highlighted: false,
        tags: ['accommodation', 'hotels'],
      },
      {
        id: 'restaurants',
        text: `Suggest some good restaurants in ${cityName}.`,
        highlighted: false,
        tags: ['dining', 'restaurants'],
      },
      {
        id: 'attractions',
        text: `What are the top attractions in ${cityName}?`,
        highlighted: false,
        tags: ['attractions', 'sightseeing'],
      },
      {
        id: 'events',
        text: `What are ${cityName}'s upcoming events?`,
        highlighted: false,
        tags: ['events', 'activities'],
      },
    ];
  }

  private loadUserChatHistory(isDisplayAfterLoading = false) {
    const user = this.userFromStorage;
    if (user) {
      this.isLoadingUserChatHistory = true;
      this.cdRef.detectChanges();
      // define a date that is 7 days before
      const _7daysBefore = new Date();
      _7daysBefore.setDate(_7daysBefore.getDate() - 7);

      this._visitorService
        .getTravelBuddyConversationByUser(this.hubName, user.userId, _7daysBefore)
        .pipe(
          finalize(() => {
            timer(2000).subscribe(() => {
              this.isLoadingUserChatHistory = false;
            });
          }),
        )
        .subscribe((conversations) => {
          this.userChatHistory = conversations && conversations.length ? conversations : [];
          this.isUserChatHistoryReady = true;
          this.msgHistory = [];
          if (isDisplayAfterLoading) {
            this.isShowLogin = false;
            this.displayUserChatHistory();
            this.send(true);
          }
        });
    } else {
      this.isUserChatHistoryReady = true;
      if (isDisplayAfterLoading) {
        this.isShowLogin = false;
        this.send(true);
      }
    }
  }

  get userFromStorage() {
    const email = this._localStorage.getItem('travelbuddy_user_email');
    if (email) return { userId: email, avatar: undefined, userName: email };

    const googleUser = localStorage.getItem('social.login.googleUser');

    if (googleUser) {
      const googleUserObj = JSON.parse(googleUser);
      return {
        userId: googleUserObj.userId,
        avatar: googleUserObj.profilePicture,
        userName: googleUserObj.userName,
      };
    }

    const facebookUser = localStorage.getItem('social.login.facebookUser');

    if (facebookUser) {
      const facebookUserObj = JSON.parse(facebookUser);
      return {
        userId: facebookUserObj.userId,
        avatar: facebookUserObj.profilePicture,
        userName: facebookUserObj.userName,
      };
    }

    return null;
  }

  get isIndicatorShowed() {
    return this._localStorage.getItem<boolean>('Travelbuddy_is_Prompt_Showed');
  }

  get canShowIndicator() {
    if (!this.travelBuddySettings) return false;

    if (this.travelBuddySettings.indicator.onlyShowOnce && !this.isIndicatorShowed) return true;
    if (this.travelBuddySettings.indicator.onlyShowOnce && this.isIndicatorShowed) return false;

    return !this.isIndicatorShowedPageLevel;
  }

  getChatBoxPosition() {
    const toggleRight = parseFloat(this.right());
    const toggleLeft = parseFloat(this.left());
    const toggleTop = parseFloat(this.top());
    const toggleBottom = parseFloat(this.bottom());
    this.chatRight = toggleRight ? this.right() : 'auto';
    this.chatLeft = toggleLeft ? this.left() : 'auto';
    this.chatTop = toggleTop ? `${toggleTop + 64}px` : 'auto';

    // Set chatBottom to 32px when screen height is less than 1000px
    if (window.innerHeight < 1000) {
      this.chatBottom = '32px';
      this.isChatAreaDown = true;
    } else {
      this.chatBottom = toggleBottom ? `${toggleBottom + 64}px` : 'auto';
      this.isChatAreaDown = false;
    }
  }

  getIndicatorPosition() {
    // const toggleRight = parseFloat(this.right());
    // const toggleLeft = parseFloat(this.left());
    // const toggleTop = parseFloat(this.top());
    const toggleBottom = parseFloat(this.bottom());
    // this.chatRight = toggleRight ? this.right() : 'auto';
    // this.chatLeft = toggleLeft ? this.left() : 'auto';
    // this.chatTop = toggleTop ? `${toggleTop + 64}px` : 'auto';
    this.indicatorBottom = toggleBottom ? `${toggleBottom + 195}px` : 'auto';
  }

  checkHasScrollbar() {
    // Use requestAnimationFrame instead of 150ms setTimeout
    requestAnimationFrame(() => {
      if (this.chatContainer) {
        const div = this.chatContainer.nativeElement;
        this.hasScrollbar = div.scrollHeight > div.clientHeight;
      }
    });

    if (!this.isInNormalChat) {
      this.isAIRespond = this.msgHistory?.any((x) => x.type === 'AI' || x.type === 'AI_ERROR');

      if (this.isAIRespond) {
        this.isFolding = true;
        // Reduce animation delay from 700ms to 300ms for faster response
        setTimeout(() => {
          this.isFolding = false;
          this.isInNormalChat = true;
          this.cdRef.detectChanges();
        }, 300);
      }
    }
  }

  closeIndicator() {
    this.isIndicatorShowedPageLevel = true;
    this._localStorage.setItem('Travelbuddy_is_Prompt_Showed', true);
  }

  onPseudoButtonKeydown(event: KeyboardEvent) {
    if (event.key !== 'Enter' && event.key !== ' ') {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    (event.currentTarget as HTMLElement | null)?.click();
  }

  @HostListener('document:keydown', ['$event'])
  handleDocumentKeydown(event: KeyboardEvent): void {
    if (event.key !== 'Escape') {
      return;
    }

    const target = event.target as HTMLElement | null;
    if (target?.closest('.mat-mdc-menu-panel, [role="menu"], .mat-datepicker-content')) {
      return;
    }

    if (this.isShowLoginPopup) {
      event.preventDefault();
      this.closeLoginPopup();
      return;
    }

    if (this.isSharedTripModalOpen) {
      event.preventDefault();
      this.closeSharedTripOverlay();
      return;
    }

    if (this.isShow) {
      event.preventDefault();
      this.show();
    }
  }

  private getActiveElement(): HTMLElement | null {
    const activeElement = this._document.activeElement;
    return activeElement instanceof HTMLElement ? activeElement : null;
  }

  private isVisibleElement(element: HTMLElement): boolean {
    const style = window.getComputedStyle(element);
    return style.display !== 'none' && style.visibility !== 'hidden' && element.getClientRects().length > 0;
  }

  private getFocusableElements(root: HTMLElement): HTMLElement[] {
    return Array.from(root.querySelectorAll<HTMLElement>(this.focusableSelector)).filter(
      (element) =>
        !element.hasAttribute('disabled') &&
        element.getAttribute('aria-hidden') !== 'true' &&
        !element.hasAttribute('inert') &&
        this.isVisibleElement(element),
    );
  }

  private focusFirstElementInDialog(root: HTMLElement | null, preferredElement?: HTMLElement | null): void {
    requestAnimationFrame(() => {
      if (!root) {
        return;
      }

      if (preferredElement && this.isVisibleElement(preferredElement)) {
        preferredElement.focus();
        return;
      }

      const firstFocusableElement = this.getFocusableElements(root)[0];
      (firstFocusableElement || root).focus();
    });
  }

  private restoreFocus(element: HTMLElement | null): void {
    requestAnimationFrame(() => {
      if (element && this._document.contains(element)) {
        element.focus();
      }
    });
  }

  show() {
    const wasOpen = this.isShow;
    if (!wasOpen) {
      this.lastChatTriggerElement = this.getActiveElement();
    }

    this.isShow = !this.isShow;
    if (this.isShow) {
      this._localStorage.setItem('Travelbuddy_is_Prompt_Showed', true);
      this.isIndicatorShowedPageLevel = true;

      const url = new URL(window.location.href);
      url.searchParams.set('show-ai-travel-planner', 'true');
      this.location.go(url.pathname, url.searchParams.toString());

      // get user chat history
      // show user chat history (which is loaded from DB) when the first time opens TravelBuddy
      // if user close TravelBuddy and open again, loads his chat history from msgHistory
      if (!this.msgHistory?.length) {
        this.displayUserChatHistory();
      } else {
        requestAnimationFrame(() => {
          this.scrollToBottom();
          this.userProfilePicture = this.userFromStorage?.avatar;
          this.focusFirstElementInDialog(this.container?.nativeElement, this.chatInput?.nativeElement);
        });
      }
    }

    if (!this.isShow) {
      this.closeSharedTripOverlay(false);
      const url = new URL(window.location.href);
      url.searchParams.delete('show-ai-travel-planner');
      this.location.go(url.pathname, url.searchParams.toString());

      this.resetStepShowing();
      this.restoreFocus(this.lastChatTriggerElement);
    } else {
      requestAnimationFrame(() => {
        let index = 0;
        this.buildStepShowing(index);
        this.focusFirstElementInDialog(this.container?.nativeElement, this.chatInput?.nativeElement);
      });
    }
  }

  isGeneratingTrip = false;
  convertAndSaveAITrip($event) {
    this.isGeneratingTrip = true;
    this._visitorService
      .sendAIQuery(
        this.hubName,
        'organize-trip-from-travel-buddy-response',
        'chatgpt',
        $event.message.msg,
        [],
        JSON.stringify(
          $event.message.placesMatched.map((x) => {
            return {
              name: x.name,
              _id: x._id,
              categoryList: x.categoryList,
            };
          }),
        ),
      )
      .pipe(
        catchError((error) => {
          console.error(error);
          return of({
            success: false,
          });
        }),
        finalize(() => {
          this.isGeneratingTrip = false;
          $event?.callback ? $event.callback() : null;
        }),
      )
      .subscribe(async (data) => {
        if (data.success) {
          const json = JSON.parse(data.data);
          console.log(json);
          let days = [];

          let index = 1;
          for (const day of Object.keys(json.itinerary)) {
            // if (!day || !day.startsWith('day')) continue;
            let attractionIndex = 0;

            let prePlans = [];
            let currentDay = {
              date: null,
              dateText: `Day ${index++}`,
              note: '',
              attractions: [],
            };

            for (const placeFromAI of json.itinerary[day]) {
              prePlans = [
                {
                  time: placeFromAI.time,
                  title: placeFromAI.activity,
                  type: planTypes.find((x) => x.type === placeFromAI.activity)?.type || 'Custom',
                  content: placeFromAI.description,
                },
              ];

              currentDay.attractions.push({
                feedType: 'place',
                feedId: placeFromAI._id,
                order: attractionIndex++,
                prePlans: prePlans,
                postPlans: [],
                // item: !SocialLoginComponent.isUserLoggedIn ? placeInAnswer : undefined,
              });
            }

            days.push(currentDay);

            // const addDay = this.timeService.addToDate(this.newDay, 'day', 1);
            // this.newDay = addDay.toDate();
            // console.log('newDay', this.newDay);
            // this.editDayText = this.timeService.getOnlyDisplayDate(this.newDay);
          }
          console.log('days', days);

          this.saveTrip(days, $event.title);
        }
      });
  }

  copyTrip($event) {
    this.saveTrip($event.days, $event.title, this.sharedUserTripId, this.sharedSingleTripId);
  }

  onTripEditorRequireLogin($event?: { action?: 'copyTrip'; trip?: any }) {
    if ($event?.action === 'copyTrip' && $event.trip) {
      this.pendingTripCopyAfterLogin = $event.trip;
    }

    this.showLoginPopup();
  }

  private continuePendingTripCopyAfterLogin() {
    if (!this.pendingTripCopyAfterLogin || !this.isUserLoggedIn) {
      return;
    }

    const tripToCopy = this.pendingTripCopyAfterLogin;
    this.pendingTripCopyAfterLogin = null;
    this.copyTrip(tripToCopy);
  }

  saveTrip(days, title, copyFromUserTrip?: string, copyFromSingleTrip?: string) {
    const userInfo = this.getUserContext();

    if (!userInfo.userId) {
      alert('Please login to save trip');
      return;
    }

    const newTrip = {
      id: guid(),
      title: title,
      hubName: this.hubName,
      days,
      createdAt: new Date().toISOString(),
      userFacebookId: userInfo.userId || null,
      source: 'tb' as 'tb' | 'user',
      travelMode: 'DRIVING' as TravelMode,
    };

    if (copyFromUserTrip) {
      newTrip['copyFromUserTrip'] = copyFromUserTrip;
    }
    if (copyFromSingleTrip) {
      newTrip['copyFromSingleTrip'] = copyFromSingleTrip;
    }

    this._visitorService
      .createTripV3(this.hubName, {
        singleTrip: newTrip,
        userFacebookId: userInfo.userId,
      })
      .pipe(
        takeUntil(this.isDestroyed),
        finalize(async () => {}),
      )
      .subscribe(async () => {
        await this.loadUserSavedAITrips();
        this.showSuccess('Trip saved successfully');
        this.flashSavedTripPanel();

        if (copyFromUserTrip) {
          this.closeSharedTripOverlay();
          this.closeDetailsPanel();
          this.hasSharedTripInUrl = false;
          const cleanUrl = new URL(window.location.href);
          cleanUrl.searchParams.delete('user-trip');
          cleanUrl.searchParams.delete('single-trip');
          this.location.go(cleanUrl.pathname, cleanUrl.searchParams.toString());
        }
      });
  }

  isDeletingTrip = false;
  removeAITrip(event: ButtonTriggerEvent, trip, trigger: MatMenuTrigger) {
    const userInfo = this.getUserContext();
    this._visitorService
      .deleteTrip(this.hubName, userInfo.userId, trip.id)
      .pipe(
        finalize(() => {
          this.isDeletingTrip = false;
          event?.complete();
        }),
      )
      .subscribe(() => {
        if (this.selectedAITrip) {
          this.closeDetailsPanel();
        }
        this.loadUserSavedAITrips();
        trigger?.closeMenu();
      });
  }

  // New method for starting a new chat
  startNewChat() {
    // Safety net: cleanly isolate any in-progress stream
    if (this.isWaitingForAIResponse) {
      this.isWaitingForAIResponse = false;
      this.aiResTextContent = '';
    }

    this.msgHistory = [];
    this.currentChat = null;
    this.isShowLandscreen = true;
    this.isShowFeaturedPlaces = true;
    this.isInNormalChat = false;
    this.isAIRespond = false;
    this.isFolding = false;
    this.currentChatTitle = ''; // Reset chat title
    this.isMobile && (this.isSidebarCollapsed = true);
    this.closeDetailsPanel();
    this.cdRef.detectChanges();
  }

  // Toggle sidebar collapse for desktop
  toggleSidebarCollapse() {
    this.isSidebarCollapsed = !this.isSidebarCollapsed;
    if (!this.isSidebarCollapsed) {
      this.isMapOpen = false;
      this.isDetailsOpen = false;
    }
  }

  // Toggle recent chats section
  toggleRecentChats() {
    this.isRecentChatsExpanded = !this.isRecentChatsExpanded;
  }

  // Toggle map panel (desktop only)
  toggleMap(msg: ITravelAssistantMessage) {
    this.isDetailsOpen = false;
    this.selectedAITrip = null;
    // this.isMapOpen = !this.isMapOpen;
    this.isMapOpen = true;
    this.welcomePageMapMarkers = [];
    this.currentMsgForMap = msg;
    this.directionLocations = [];
    this.directionType = undefined;
    if (this.googleMap) {
      this.googleMap.directionsResults$ = of(null);
    }
    this.cdRef.detectChanges();

    if (msg.placesMatched?.length) {
      for (const place of msg.placesMatched) {
        try {
          this.welcomePageMapMarkers.push({
            position: {
              lat: place.lat || place.address?.lat,
              lng: place.lng || place.address?.lng,
            },
            label: {
              text: '📍 ' + place.name,
              fontWeight: 'normal',
              className:
                'bg-white text-black px-2 py-1 border border-black rounded shadow-lg -translate-y-6 z-0 relative',
            },
            title: place['feedId'] || place._id,
            data: place,
          } as IMapMarkerWithCustomData<VisitorPlace>);
          console.log(
            `Place added: ${place.name} (nameId: ${place.nameId}, hubName: ${place.hubName})`,
          );
        } catch (error) {
          console.error(
            `Failed to add place: ${place.name} (nameId: ${place.nameId}, hubName: ${place.hubName})`,
            error,
          );
        }
      }
    }

    if (msg.eventsMatched?.length) {
      for (const event of msg.eventsMatched) {
        if (!event.isOnlineEvent) {
          this.welcomePageMapMarkers.push({
            position: {
              lat: event.lat || event.address?.lat,
              lng: event.lng || event.address?.lng,
            },
            label: {
              text: '🎉 ' + event.name,
              fontWeight: 'normal',
              className:
                'bg-white text-black px-2 py-1 border border-blue-500 rounded shadow-lg -translate-y-6 z-0 relative',
            },
            title: event._id,
            data: event,
          } as IMapMarkerWithCustomData<VisitorEvent>);
        }
      }
    }

    if (this.isMapOpen) {
      this.scrollTop = this.chatContainer.nativeElement.scrollTop;
      setTimeout(() => {
        this.googleMap?.fitBounds();
      });
    }
  }

  closeMap() {
    this.isMapOpen = false;
    setTimeout(() => {
      if (this.chatContainer) {
        this.chatContainer.nativeElement.scrollTop = this.scrollTop;
      }
    }, 350);
  }

  onMapAttractionOpened(): void {
    if (this.isMobile && this.isMapOpen) {
      this.isMapOpen = false;
    }
  }

  // Scroll places horizontally
  scrollPlaces(direction: 'left' | 'right') {
    if (!this.placesScrollContainer) return;

    const container = this.placesScrollContainer.nativeElement;
    const scrollAmount = 300; // pixels to scroll

    if (direction === 'left') {
      container.scrollLeft -= scrollAmount;
    } else {
      container.scrollLeft += scrollAmount;
    }

    // Update scroll state using requestAnimationFrame
    requestAnimationFrame(() => this.updateScrollState());
  }

  // Check scroll position and update arrow states
  onPlacesScroll() {
    this.updateScrollState();
  }

  private updateScrollState() {
    if (!this.placesScrollContainer) return;

    const container = this.placesScrollContainer.nativeElement;
    this.canScrollLeft = container.scrollLeft > 0;
    this.canScrollRight = container.scrollLeft < container.scrollWidth - container.clientWidth - 1;
    this.cdRef.detectChanges();
  }

  // Get selected preferences as text
  getSelectedPreferencesText(): string {
    const selected = this.tripPreferences.filter((p) => p.selected).map((p) => p.name);
    return selected.length > 0 ? selected.join(', ') : 'None selected';
  }

  // Check if logo is an image URL or text
  isLogoImage(logo: string): boolean {
    if (!logo) return false;
    // Check if it's a URL (starts with http/https or has image extension)
    return (
      logo.startsWith('http') ||
      logo.startsWith('data:image') ||
      /\.(jpg|jpeg|png|gif|svg|webp)$/i.test(logo)
    );
  }

  togglePreference(preference: any) {
    preference.selected = !preference.selected;
    if (preference.selected) {
      if (!this.selectedPreferences.includes(preference._id)) {
        this.selectedPreferences.push(preference._id);
      }
    } else {
      const index = this.selectedPreferences.indexOf(preference._id);
      if (index > -1) {
        this.selectedPreferences.splice(index, 1);
      }
    }
  }

  toggleFlexibleDates() {
    this.isFlexibleDates = !this.isFlexibleDates;
    if (this.isFlexibleDates) {
      this.selectedDateRange = null;
      this.dateRangePicker.reset();
    }
  }

  dateRangeChanged(range: { start: Date; end: Date }) {
    this.selectedDateRange = { start: range.start, end: range.end };
    if (range.start || range.end) {
      this.isFlexibleDates = false;
    }
  }

  // Format date to MM/DD/YYYY string for display in AI messages
  formatDateForDisplay(date: Date | null): string {
    if (!date) return '';
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    const year = date.getFullYear();
    return `${month}/${day}/${year}`;
  }

  getDynamicQuestionText(question: any): string {
    let text = question.text;
    const cityName = this.travelBuddySettings?.cityName || 'this destination';

    // Replace placeholder with actual city name
    text = text.replace('{cityName}', cityName);

    // Add selected preferences as tags to the prompt
    if (this.selectedPreferences.length > 0) {
      const preferenceNames = this.selectedPreferences.map((_id) => {
        const pref = this.tripPreferences.find((p) => p._id === _id);
        return pref ? pref.name : _id;
      });
      text += ` (Preferences: ${preferenceNames.join(', ')})`;
    }

    // Add date information
    if (this.selectedDateRange && !text.includes('Planned dates')) {
      text += ` (Planned dates: ${this.formatDateForDisplay(
        this.selectedDateRange.start,
      )} - ${this.formatDateForDisplay(this.selectedDateRange.end)})`;
    } else if (this.isFlexibleDates) {
      // text += ` (Flexible dates)`;
    }

    return text;
  }

  sendQuestionWithContext(question: any) {
    const contextualQuestion = this.getDynamicQuestionText(question);
    this.onSendClick.emit(contextualQuestion);
  }

  selectFavItem(item: VisitorPlace | VisitorEvent) {
    if (item.startTime) {
      this.selectEvent(item as VisitorEvent);
    } else {
      this.selectPlace(item as VisitorPlace);
    }
    this.isShowFeaturedPlaces = false;
  }

  loadNearbyPlaces(targetPlace: VisitorPlace) {
    return this.placeService.getNearByPlaces(targetPlace, 5, 10, 'All');
  }

  askAboutFeaturedPlace(place: VisitorPlace) {
    const primaryCategory = `${place.category || ''}`
      .split(',')
      .map((category) => this.placeService.toReadableCategory(category))
      .find((category) => !!category);
    const categoryContext = primaryCategory
      ? `, whose primary category is "${primaryCategory}"`
      : '';
    const prompts = [
      `What should I know about the place "${place.name}"${categoryContext} as a visitor?`,
      `If I'm standing in front of the place "${place.name}"${categoryContext} right now, what would you tell me to help me truly appreciate it?`,
      `Give me a short but fascinating introduction to the place "${place.name}"${categoryContext} that would make me want to visit immediately.`,
      `Imagine I'm walking toward the place "${place.name}"${categoryContext} with you. What would you point out first, and why?`,
      `If the place "${place.name}"${categoryContext} were your favorite stop in the city, how would you introduce it to me?`,
    ];
    this.onSendClick.emit(prompts[Math.floor(Math.random() * prompts.length)]);
  }

  scrollTop = 0;
  // Select a place and focus on it in the map
  selectPlace(place: VisitorPlace | VisitorEvent) {
    this.scrollTop = this.chatContainer.nativeElement.scrollTop;

    this.selectedPlaceOrEvent = place;
    this.isMapOpen = false;
    this.isDetailsOpen = true;
    this.selectedAITrip = null;

    this.cdRef.detectChanges();

    // check if place is fully loaded in cache. If so, address_components will be available
    // p.id === place._id: for newly searched places, _id is Google id
    const placeInCache = this.allPlaces.find((p) => p._id === place._id || p.id === place._id);
    if (placeInCache && placeInCache.address_components) {
      // place.reviews is loaded from Google API for temporary loading, placeInCache.googleReviews is loaded from Serp API which has more data
      if (this.selectedPlaceOrEvent['reviews']?.length && !placeInCache.googleReviews?.length) {
        placeInCache.googleReviews = this.selectedPlaceOrEvent['reviews'];
      }
      this.selectedPlaceOrEvent = placeInCache;
      this.loadNearbyPlacesWithCache(placeInCache);

      // setTimeout(() => {
      //   if (this.chatContainer) {
      //     this.chatContainer.nativeElement.scrollTop = this.scrollTop;
      //   }
      //   if (this.detailsPanel) {
      //     this.detailsPanel.nativeElement.scrollTop = 0;
      //   }
      // }, 200);
      return;
    }

    this.isLoadingDetails = true;

    this.placeService.getPlaces(this.hubName, { id: place._id }).subscribe((places) => {
      // place.reviews is loaded from Google API for temporary loading, placeInCache.googleReviews is loaded from Serp API which has more data
      if (places[0]['reviews']?.length && !places[0].googleReviews?.length) {
        places[0].googleReviews = places[0]['reviews'];
      }
      this.selectedPlaceOrEvent = places[0];
      this.loadNearbyPlacesWithCache(places[0]);
      this.isLoadingDetails = false;

      const placeInCache = this.allPlaces.find((p) => p._id === place._id || p.id === place._id);
      if (!placeInCache) {
        this.allPlaces.push(places[0]);
      }

      // replace cache
      this.allPlaces = this.allPlaces.map((p) =>
        p._id === place._id || p.id === place._id ? places[0] : p,
      );

      // setTimeout(() => {
      //   if (this.chatContainer) {
      //     this.chatContainer.nativeElement.scrollTop = this.scrollTop;
      //   }
      //   if (this.detailsPanel) {
      //     this.detailsPanel.nativeElement.scrollTop = 0;
      //   }
      // }, 200);
    });

    // setTimeout(() => {
    //   if (this.chatContainer) {
    //     this.chatContainer.nativeElement.scrollTop = this.chatContainer.nativeElement.scrollHeight;
    //   }
    //   if (this.detailsPanel) {
    //     this.detailsPanel.nativeElement.scrollTop = 0;
    //   }
    // });
  }

  private loadNearbyPlacesWithCache(targetPlace: VisitorPlace) {
    if (!targetPlace) {
      this.nearbyPlaces = [];
      this.isLoadingNearbyPlaces = false;
      return;
    }

    const cacheKey = this.getNearbyPlacesCacheKey(targetPlace);
    if (this.nearbyPlacesCache.has(cacheKey)) {
      this.nearbyPlaces = this.nearbyPlacesCache.get(cacheKey) || [];
      this.isLoadingNearbyPlaces = false;
      return;
    }

    this.isLoadingNearbyPlaces = true;
    this.loadNearbyPlaces(targetPlace)
      .pipe(
        takeUntil(this.isDestroyed),
        finalize(() => {
          this.isLoadingNearbyPlaces = false;
        }),
      )
      .subscribe((places) => {
        const cachedNearbyPlaces = places || [];
        this.nearbyPlaces = cachedNearbyPlaces;
        this.nearbyPlacesCache.set(cacheKey, cachedNearbyPlaces);
      });
  }

  private getNearbyPlacesCacheKey(targetPlace: VisitorPlace): string {
    return targetPlace?._id || (targetPlace as any)?.id || targetPlace?.name || '';
  }

  selectEvent(event: VisitorEvent) {
    this.scrollTop = this.chatContainer.nativeElement.scrollTop;

    this.eventTimeService.processEventTimes(event);
    this.selectedPlaceOrEvent = event;
    this.isMapOpen = false;
    this.isDetailsOpen = true;
    this.selectedAITrip = null;

    this.cdRef.detectChanges();

    // check if place is fully loaded in cache. If so, address_components will be available
    // p.id === place._id: for newly searched places, _id is Google id
    const placeInCache = this.allEvents.find((p) => p._id === event._id || p.id === event._id);
    if (placeInCache && placeInCache.address) {
      this.eventTimeService.processEventTimes(placeInCache);
      this.selectedPlaceOrEvent = placeInCache;
    }

    // setTimeout(() => {
    //   if (this.chatContainer) {
    //     this.chatContainer.nativeElement.scrollTop = this.chatContainer.nativeElement.scrollHeight;
    //   }
    //   if (this.detailsPanel) {
    //     this.detailsPanel.nativeElement.scrollTop = 0;
    //   }
    // });
  }

  // Close the details panel
  closeDetailsPanel() {
    this.isDetailsOpen = false;
    this.selectedPlaceOrEvent = null;
    this.selectedAITrip = null;
    if (this.isShowLandscreen) {
      this.isShowFeaturedPlaces = true;
    }
    setTimeout(() => {
      if (this.chatContainer) {
        this.chatContainer.nativeElement.scrollTop = this.scrollTop;
      }
    }, 350);
    this.cdRef.detectChanges();
  }

  // Helper to check if selected item is an event
  get isSelectedItemEvent(): boolean {
    return this.selectedPlaceOrEvent.startTime ? true : false;
  }

  // Get selected place (if not an event)
  get selectedPlace(): VisitorPlace | null {
    return this.isSelectedItemEvent ? null : (this.selectedPlaceOrEvent as VisitorPlace);
  }

  // Get selected event (if it is an event)
  get selectedEvent(): VisitorEvent | null {
    return this.isSelectedItemEvent ? (this.selectedPlaceOrEvent as VisitorEvent) : null;
  }

  getItemRating(): number | null {
    if (!this.selectedPlaceOrEvent) return null;
    return (this.selectedPlaceOrEvent as any).rating || null;
  }

  getItemCategory(): string {
    if (!this.selectedPlaceOrEvent) return '';
    if (this.selectedPlaceOrEvent.startTime) return '';
    return this.placeService.getDisplayCategory(this.selectedPlaceOrEvent as VisitorPlace);
  }

  getItemAddress(): string {
    if (!this.selectedPlaceOrEvent) return '';
    const address = this.selectedPlaceOrEvent.address;
    if (typeof address === 'string') return address;
    return address?.address || '';
  }

  getItemPhone(): string {
    if (!this.selectedPlaceOrEvent) return '';
    return (this.selectedPlaceOrEvent as any).phone || '';
  }

  getItemWebsite(): string {
    if (!this.selectedPlaceOrEvent) return '';
    return (this.selectedPlaceOrEvent as any).website || '';
  }

  getItemDescription(): string {
    if (!this.selectedPlaceOrEvent) return '';
    const item = this.selectedPlaceOrEvent as any;
    return removeHtmlTags(item.description || item.about || '');
  }

  getItemOpeningHours() {
    if (!this.selectedPlaceOrEvent) return '';
    if (this.selectedPlaceOrEvent.startTime) return '';
    return (this.selectedPlaceOrEvent as any).opening_hours || '';
  }

  // Track expanded state of reviews
  private expandedReviews = new Set<string>();

  getGoogleReviews() {
    if (!this.selectedPlaceOrEvent) return [];
    return (
      (this.selectedPlaceOrEvent as any).googleReviews
        ?.filter((r: any) => r.rating >= 3)
        .slice(0, 8) || []
    );
  }

  // Toggle review expansion state
  toggleReviewExpansion(review: any) {
    const reviewText = this.getReviewText(review);
    const reviewId = review.name || reviewText?.substring(0, 50); // Use name or first 50 chars as ID
    if (this.expandedReviews.has(reviewId)) {
      this.expandedReviews.delete(reviewId);
    } else {
      this.expandedReviews.add(reviewId);
    }
    // Trigger change detection
    this.cdRef.detectChanges();
  }

  // Check if a review is expanded
  isReviewExpanded(review: any): boolean {
    const reviewText = this.getReviewText(review);
    const reviewId = review.name || reviewText?.substring(0, 50);
    return this.expandedReviews.has(reviewId);
  }

  getReviewText(review: any) {
    return review?.text?.text || review.text;
  }

  getReviewTime(review: any) {
    return (
      review.relativePublishTimeDescription ||
      (review.dateTimeISOString ? new Date(review.dateTimeISOString).toLocaleDateString() : '')
    );
  }

  // Open full details modal
  openFullDetailsModal() {
    if (!this.selectedPlaceOrEvent) return;

    const itemType: 'event' | 'place' = this.isSelectedItemEvent ? 'event' : 'place';
    const context = {
      itemType,
      item: this.selectedPlaceOrEvent,
      hubName: this.hubName,
      frontendSettings: this.frontendSettings,
      source: 'travelBuddy' as const,
      routeApiKey: this.activatedRoute?.snapshot?.queryParams?.['key'],
      previewOwnerDestroyed: this.isDestroyed,
    };

    if (this.ssrDetailNavigationService.navigateToDetail(context)) {
      return;
    }

    if (this.ssrDetailNavigationService.shouldUseTravelBuddySsrIframeFallback(context) &&
      this.ssrDetailNavigationService.openDetailPreview(context)) {
      return;
    }

    if (itemType === 'event') {
      this.openEventInModal(this.selectedPlaceOrEvent as VisitorEvent);
      return;
    }

    this.openPlaceInModal(this.selectedPlaceOrEvent as VisitorPlace);
  }

  // Open place in full modal for complete details
  openPlaceInModal(place: VisitorPlace) {
    this._modalService.show({
      component: FancyPlaceDetailsModalComponent,
      panelClass: 'ig-modal-w-full',
      data: {
        currentPlace: place,
        // placeDetailsId: place.nameId,
        from: 'placeCalendar',
      } as IPlaceDetailsModalData,
    });
  }

  // Open event in full modal for complete details
  openEventInModal(event: VisitorEvent) {
    this._modalService.show({
      component: FancyEventDetailsModalComponent,
      panelClass: 'ig-modal-w-full',
      data: {
        currentEvent: event,
        allEvents: this.allEvents || [],
        favCustomEvents: [],
        from: 'placeCalendar',
      } as IEventDetailsModalData,
    });
  }

  // View place/event on map
  viewOnMap(item: VisitorPlace | VisitorEvent) {
    // Close details panel and open map
    this.isDetailsOpen = false;
    this.isMapOpen = true;
    console.log('isMapOpen 2');

    this.welcomePageMapMarkers = [
      {
        position: {
          lat: item.lat || item.address?.lat,
          lng: item.lng || item.address?.lng,
        },
        label: {
          text: '📍 ' + item.name,
          fontWeight: 'normal',
          className:
            'bg-white text-black px-2 py-1 border border-black rounded shadow-lg -translate-y-6 z-0 relative',
        },
        title: item['feedId'] || item._id,
        data: item,
      } as IMapMarkerWithCustomData<VisitorPlace>,
    ];

    this.cdRef.detectChanges();

    // Focus on the marker
    requestAnimationFrame(() => {
      if (this.googleMap && this.googleMap.googleMap && this.welcomePageMapMarkers[0]) {
        const marker = this.welcomePageMapMarkers[0];
        const nativeMap = this.googleMap.googleMap as any;
        nativeMap.panTo(marker.position);
        nativeMap.setZoom(15);
      }
    });
  }

  // Reset map state for new AI responses
  private resetMapState(): void {
    console.log('---------------------resetMapState called-------------------');

    // Reset all map and route state
    this.matchedPlaces = [];
    this.matchedEvents = [];
    this.welcomePageMapMarkers = [];
    this.directionType = undefined;
    this.directionLocations = [];
  }

  eventTitleMap: Map<string, (typeof this.allEvents)[0]> = null;
  // Match AI-mentioned places with real place data
  private matchPlacesAndEvents(msg: ITravelAssistantMessage, isLoadExistingChat = false): void {
    console.log(
      '%c---------------------matchPlacesAndEvents called-------------------',
      'color: yellow',
    );
    console.log('msg:', msg);
    console.log('allPlaces count:', this.allPlaces?.length || 0);
    console.log('allEvents count:', this.allEvents?.length || 0);

    // Note: Map state is already reset by resetMapState() in createMsg

    // Track already matched IDs to prevent duplicates
    const matchedPlaceIds = new Set<string>();
    const matchedEventIds = new Set<string>();
    this.matchedPlaces = [];
    this.matchedEvents = [];
    let reloadPlaceFor = [];

    const isNeedMatchPlaces =
      !msg.askForEvents || (msg.askForEvents && !msg.eventsMentioned.length);

    if (isNeedMatchPlaces) {
      if (isLoadExistingChat) {
        if (msg.placesMatched && msg.placesMatched.length > 0) {
          this.matchedPlaces = msg.placesMatched;
        } else {
          for (const placeMentioned of msg.placesMentioned) {
            const place = this.findBestPlaceNameMatch(placeMentioned, this.allPlaces);
            console.log(`Place matched for ${placeMentioned?.name}`, place);
            if (place && !matchedPlaceIds.has(place.id || place._id)) {
              this.matchedPlaces.push(place);
              matchedPlaceIds.add(place.id || place._id);
            }
          }
        }
      } else {
        for (const placeMentioned of msg.placesMentioned) {
          if (msg.placeInList && msg.placeInList.length > 0) {
            const placeInList = this.findBestPlaceNameMatch(placeMentioned, msg.placeInList);
            const placeInListId = placeInList && (placeInList.id || placeInList._id);
            if (placeInList && !matchedPlaceIds.has(placeInListId)) {
              this.matchedPlaces.push(placeInList);
              console.log(
                `%cMatched "${placeMentioned.name}" from placeInList`,
                'color: lime',
                placeInList,
              );
              matchedPlaceIds.add(placeInListId);
            }
          }
          if (msg.placeSearch && msg.placeSearch.length > 0) {
            const placeInSearch = this.findBestPlaceNameMatch(placeMentioned, msg.placeSearch);
            const searchedPlace = placeInSearch && placeInSearch['searchedPlace'];
            const searchedPlaceId = searchedPlace && (searchedPlace.id || searchedPlace._id);
            if (placeInSearch && searchedPlace && !matchedPlaceIds.has(searchedPlaceId)) {
              placeInSearch['searchedPlace'].alias = placeInSearch.alias;
              placeInSearch['searchedPlace'].id = placeInSearch['searchedPlace']._id;
              this.matchedPlaces.push(placeInSearch['searchedPlace']);
              console.log(
                `%cMatched "${placeMentioned.name}" from placeSearch`,
                'color: lime',
                placeInSearch['searchedPlace'],
              );
              matchedPlaceIds.add(placeInSearch['searchedPlace'].id);
              reloadPlaceFor.push(placeInSearch['searchedPlace']);
            }
            // for (const searchedPlace of msg.placeSearch) {
            //   const normalizedName = searchedPlace.name.toLowerCase().trim();
            //   if (searchedPlace && searchedPlace['searchedPlace']) {
            //   const place = searchedPlace['searchedPlace'];
            //   this.matchedPlaces.push(place);
            //   console.log(`Matched "${normalizedName}" from AI placeSearch`);
            //   console.log(`%cplace searched`, 'color: yellow', place);

            //   let placeInCache = this.allPlaces.find((p) => p.id === place._id);
            //   if (!placeInCache) {
            //     place.id = place._id;
            //     this.allPlaces.push(place);
            //     console.log(`%cplace not found in cache, added`, 'color: red', this.allPlaces);
            //     reloadPlaceFor.push(place);
            //   }
            // }
          }
        }
      }
    }

    // Match places
    // if user asks for events, ignore showing the event venue places images
    // but if there is no events, AI may suggest some places instead, then show place images
    // if (
    //   msg.placesMentioned &&
    //   this.allPlaces &&
    //   isNeedMatchPlaces
    // ) {
    //   // Create name index for O(1) lookups (case-insensitive)
    //   const placeNameMap = new Map<string, (typeof this.allPlaces)[0]>();
    //   this.allPlaces.forEach((p) => {
    //     if (p.name) placeNameMap.set(p.name.toLowerCase().trim(), p);
    //   });

    //   for (const placeName of msg.placesMentioned) {
    //     const normalizedName = placeName.toLowerCase().trim();

    //     // Try exact match first (O(1) lookup)
    //     let place = placeNameMap.get(normalizedName);

    //     // If no exact match, try placeSearch from AI (these are pre-matched by the AI)
    //     if (!place && msg.placeSearch) {
    //       const searchedPlace = msg.placeSearch.find(
    //         (p) => p.name?.toLowerCase().trim() === normalizedName
    //       );
    //       if (searchedPlace && searchedPlace['searchedPlace']) {
    //         place = searchedPlace['searchedPlace'];
    //         console.log(`Matched "${placeName}" from AI placeSearch`);
    //         console.log(`%cplace searched`, 'color: yellow', place);

    //         let placeInCache = this.allPlaces.find((p) => p.id === place._id);
    //         if (!placeInCache) {
    //           place.id = place._id;
    //           this.allPlaces.push(place);
    //           console.log(`%cplace not found in cache, added`, 'color: red', this.allPlaces);
    //           reloadPlaceFor.push(place);
    //         }
    //       }
    //     }

    //     if (!place) {
    //       let maxSimilarity = 0,
    //         placeWithMaxSimilarity = null;

    //       for (const p of this.allPlaces) {
    //         const similar = this.similarity(p.name, placeName);
    //         if (similar > 0.8) {
    //           place = p;
    //           break;
    //         }

    //         if (similar > maxSimilarity) {
    //           placeWithMaxSimilarity = p;
    //           maxSimilarity = similar;
    //         }
    //       }
    //       if (!place && maxSimilarity > 0.6) {
    //         place = placeWithMaxSimilarity;
    //       }
    //       console.log(`Place find using similarity for ${placeName}`, place);
    //     }

    //     if (place && !matchedPlaceIds.has(place._id)) {
    //       matchedPlaceIds.add(place._id);
    //       this.matchedPlaces.push(place);
    //     } else if (place && !place.nameId) {
    //       console.warn(`⚠️ Skipped place "${place.name}" - missing nameId`);
    //     } else if (place && !place.hubName) {
    //       console.warn(`⚠️ Skipped place "${place.name}" - missing hubName`);
    //     }
    //   }
    // }

    // Match events by ID
    if (msg.eventsIds?.length && this.allEvents) {
      console.log('%cMatching events by IDs...', 'color: yellow', msg.eventsIds);
      const eventIdMap = new Map<string, (typeof this.allEvents)[0]>();
      this.allEvents.forEach((e) => {
        if (e._id) eventIdMap.set(e._id.toLowerCase().trim(), e);
      });

      let index = 0;
      for (const eventId of msg.eventsIds) {
        const normalizedId = eventId.toLowerCase().trim();

        let event = eventIdMap.get(normalizedId);

        if (!event) {
          console.warn(
            `No exact match found for event "${eventId}" - skipping fuzzy match for performance`,
          );

          event = this.fuzzyMatchEvent(msg.eventsMentioned[index], normalizedId);
        }

        if (event && !matchedEventIds.has(event._id)) {
          matchedEventIds.add(event._id);
          this.matchedEvents.push(event);

          console.log(`Event added by id: ${event.name} (nameId: ${event.nameId})`);
        } else if (event && !event.nameId) {
          console.warn(`⚠️ Skipped event "${event.name}" - missing nameId`);
        } else if (event && !event.hubName) {
          console.warn(`⚠️ Skipped event "${event.name}" - missing hubName`);
        }
        index++;
      }
    }

    // Match events by name as a fallback
    if (!this.matchedEvents.length && msg.eventsMentioned && this.allEvents) {
      if (!this.eventTitleMap) {
        this.eventTitleMap = new Map<string, (typeof this.allEvents)[0]>();
        this.allEvents.forEach((e) => {
          if (e.name) this.eventTitleMap.set(e.name.toLowerCase().trim(), e);
        });
      }

      for (const eventName of msg.eventsMentioned) {
        const normalizedTitle = eventName.name.toLowerCase().trim();

        let event = this.eventTitleMap.get(normalizedTitle);

        if (!event) {
          let maxSimilarity = 0;
          let eventWithMaxSimilarity = null;
          let eventByInclude = null;
          let eventByIncludeSimilarity = 0;

          for (const e of this.allEvents) {
            const similar = this.similarity(e.name, eventName.name);
            if (similar > 0.8) {
              event = e;
              break;
            }

            if (similar > maxSimilarity) {
              eventWithMaxSimilarity = e;
              maxSimilarity = similar;
            }

            if (e.name.trim().toLowerCase().includes(normalizedTitle)) {
              console.log(
                `%cEvent find using include for ${eventName}, similarity: ${similar}, maxEventByIncludeSimilarity: ${eventByIncludeSimilarity}`,
                'color: orange',
                e,
              );
              if (similar > eventByIncludeSimilarity) {
                eventByIncludeSimilarity = similar;
                eventByInclude = e;
                console.log(
                  `%cEvent find using include for ${eventName}, now candidate: `,
                  'color: orange',
                  eventByInclude,
                );
              }
            }
          }
          if (!event && maxSimilarity > 0.6) {
            event = eventWithMaxSimilarity;
          }
          if (!event) {
            event = eventByInclude;
            console.log(
              `%cEvent find using include for ${eventName}, final candidate: `,
              'color: orange',
              event,
            );
          }
          if (!event) {
            console.warn(
              `No exact match found for event "${eventName}" - skipping fuzzy match for performance`,
            );
          }
          console.log(`Event find using similarity for ${eventName}`, event);
        }

        if (event && !matchedEventIds.has(event._id)) {
          matchedEventIds.add(event._id);
          this.matchedEvents.push(event);

          console.log(
            `Event added: ${event.name} (nameId: ${event.nameId}, hubName: ${event.hubName})`,
          );
        } else if (event && !event.nameId) {
          console.warn(`⚠️ Skipped event "${event.name}" - missing nameId`);
        } else if (event && !event.hubName) {
          console.warn(`⚠️ Skipped event "${event.name}" - missing hubName`);
        }
      }
    }

    this.matchedPlaces.length > 0 &&
      this.msgHistory.length &&
      (this.msgHistory.last().placesMatched = this.matchedPlaces);
    this.matchedEvents.length > 0 &&
      this.msgHistory.length &&
      (this.msgHistory.last().eventsMatched = this.matchedEvents);

    console.log('Matched places count:', this.matchedPlaces.length);
    console.log('Matched events count:', this.matchedEvents.length);
    console.log('Map markers count:', this.welcomePageMapMarkers.length);

    // Update scroll state immediately - no setTimeout needed
    this.updateScrollState();

    if (reloadPlaceFor.length) {
      timer(8000) // wait for place to be saved to db
        .pipe(
          switchMap(() =>
            this.placeService.getPlacesByGoogleIds(
              this.hubName,
              reloadPlaceFor.map((x) => x.id),
            ),
          ),
        )
        .subscribe((places) => {
          for (const place of places) {
            let placeInCache = this.allPlaces.find((x) => x.id === place.id);
            if (!placeInCache) {
              this.allPlaces.push(place);
              console.log('%c===== reload place added', 'color: lime', this.allPlaces);
            } else {
              placeInCache.cover = place.cover;
              console.log('%c===== reload place updated', 'color: lime', placeInCache);
            }
          }
        });
    }
  }

  private fuzzyMatchEvent(eventName, eventId) {
    console.log(`Start fuzzy match events for ${eventName}`);
    if (!this.eventTitleMap) {
      this.eventTitleMap = new Map<string, (typeof this.allEvents)[0]>();
      this.allEvents.forEach((e) => {
        if (e.name) this.eventTitleMap.set(e.name.toLowerCase().trim(), e);
      });
    }

    if (!eventName) {
      console.warn(`No event name found for event ID "${eventId}" from eventsMentioned`);
      return null;
    }
    const normalizedTitle = eventName.name.toLowerCase().trim();

    let event = this.eventTitleMap.get(normalizedTitle);

    if (!event) {
      let maxSimilarity = 0;
      let eventWithMaxSimilarity = null;
      let eventByInclude = null;
      let eventByIncludeSimilarity = 0;

      for (const e of this.allEvents) {
        const similar = this.similarity(e.name, eventName.name);
        if (similar > 0.8) {
          event = e;
          break;
        }

        if (similar > maxSimilarity) {
          eventWithMaxSimilarity = e;
          maxSimilarity = similar;
        }

        if (e.name.trim().toLowerCase().includes(normalizedTitle)) {
          console.log(
            `%cEvent find using include for ${eventName}, similarity: ${similar}, maxEventByIncludeSimilarity: ${eventByIncludeSimilarity}`,
            'color: orange',
            e,
          );
          if (similar > eventByIncludeSimilarity) {
            eventByIncludeSimilarity = similar;
            eventByInclude = e;
            console.log(
              `%cEvent find using include for ${eventName}, now candidate: `,
              'color: orange',
              eventByInclude,
            );
          }
        }
      }
      if (!event && maxSimilarity > 0.6) {
        event = eventWithMaxSimilarity;
      }
      if (!event) {
        event = eventByInclude;
        console.log(
          `%cEvent find using include for ${eventName}, final candidate: `,
          'color: orange',
          event,
        );
      }
      if (!event) {
        console.warn(
          `No exact match found for event "${eventName}" - skipping fuzzy match for performance`,
        );
      }
      console.log(`Event find using similarity for ${eventName}`, event);
    }

    return event;
  }

  private normalizePlaceMatchName(value: string): string {
    return String(value || '')
      .toLowerCase()
      .replace(/&/g, ' and ')
      .replace(/[^a-z0-9]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  private findBestPlaceNameMatch(
    placeMentioned: { name: string; city?: string },
    places: any[],
  ): any {
    const inputName = this.normalizePlaceMatchName(placeMentioned?.name);
    if (!inputName || !places?.length) return null;

    const inputTokens = Array.from(new Set(inputName.split(' ').filter(Boolean)));
    const genericTokens = new Set([
      'and', 'at', 'center', 'centre', 'downtown', 'hotel', 'hotels', 'inn', 'lodge',
      'lodging', 'motel', 'resort', 'restaurant', 'suites', 'the',
    ]);
    const hasDistinctiveInputToken = inputTokens.some(
      (token) => token.length >= 4 && !genericTokens.has(token),
    );
    const normalizedCity = this.normalizePlaceMatchName(placeMentioned?.city).split(' ')[0];
    const candidates: { place: any; score: number; method: string }[] = [];

    for (const place of places) {
      if (!place?.name) continue;
      let bestScore = 0;
      let method = '';

      for (const rawCandidateName of [place.name, place.alias].filter(Boolean)) {
        const candidateName = this.normalizePlaceMatchName(rawCandidateName);
        if (candidateName === inputName) {
          bestScore = 1;
          method = rawCandidateName === place.alias ? 'normalized_alias' : 'normalized_name';
          break;
        }

        const editScore = this.similarity(inputName, candidateName);
        if (editScore > bestScore) {
          bestScore = editScore;
          method = 'similarity';
        }

        const candidateTokens = new Set(candidateName.split(' ').filter(Boolean));
        const matchedTokens = inputTokens.filter((token) => candidateTokens.has(token));
        if (inputTokens.length >= 2 && hasDistinctiveInputToken && matchedTokens.length === inputTokens.length) {
          const tokenScore = 0.9 + Math.min((matchedTokens.length / candidateTokens.size) * 0.05, 0.05);
          if (tokenScore > bestScore) {
            bestScore = tokenScore;
            method = 'input_token_coverage';
          }
        }
      }

      if (normalizedCity) {
        const locationText = this.normalizePlaceMatchName(
          [place.name, place.address, place.formattedAddress].filter(Boolean).join(' '),
        );
        if (locationText.split(' ').includes(normalizedCity)) {
          bestScore += 0.05;
          method += '+city';
        }
      }

      if (bestScore > 0.8) candidates.push({ place, score: bestScore, method });
    }

    candidates.sort((left, right) => right.score - left.score);
    if (!candidates.length) return null;

    const best = candidates[0];
    const second = candidates[1];
    if (second && best.score < 1 && best.score - second.score < 0.03) {
      console.warn(
        `Ambiguous place match for "${placeMentioned.name}": ` +
          `${best.place.name} (${best.score.toFixed(3)}) vs ` +
          `${second.place.name} (${second.score.toFixed(3)})`,
      );
      return null;
    }

    console.log(
      `Matched "${placeMentioned.name}" to "${best.place.name}" ` +
        `by ${best.method}, score=${best.score.toFixed(3)}`,
    );
    return best.place;
  }

  // Calculate string similarity (Dice's Coefficient)
  private similarity(s1: string, s2: string): number {
    if (!s1 || !s2) return 0;

    const str1 = s1.toLowerCase().trim();
    const str2 = s2.toLowerCase().trim();

    if (str1 === str2) return 1;

    const len1 = str1.length;
    const len2 = str2.length;

    if (len1 < 2 || len2 < 2) return 0;

    const bigrams1 = new Set<string>();
    for (let i = 0; i < len1 - 1; i++) {
      bigrams1.add(str1.substring(i, i + 2));
    }

    let matches = 0;
    for (let i = 0; i < len2 - 1; i++) {
      const bigram = str2.substring(i, i + 2);
      if (bigrams1.has(bigram)) {
        matches++;
        bigrams1.delete(bigram);
      }
    }

    return (2.0 * matches) / (len1 + len2 - 2);
  }

  // Check if the message is the current/latest AI message
  isCurrentMessage(msg: ITravelAssistantMessage): boolean {
    if (!this.msgHistory || this.msgHistory.length === 0) return false;

    const latestAIMessage = this.msgHistory.filter((m) => m.type === 'AI').pop();

    return latestAIMessage && latestAIMessage.id === msg.id;
  }

  updateChatTitle() {
    if (this.currentChat) {
      this.currentChat.title = this.currentChatTitle;

      if (this.isAnonymous) {
        // Guests: save to localStorage
        console.log('Guest user - updating chat title in localStorage');
        const chatIndex = this.recentChats.findIndex((c) => c.id === this.currentChat.id);
        if (chatIndex >= 0) {
          this.recentChats[chatIndex].title = this.currentChatTitle;
        }
        this.saveRecentChatsToLocalStorage();
        this.showSuccess('Chat title updated successfully');
      } else {
        // Logged-in users: save via API
        const userContext = this.getUserContext();
        this.travelBuddyChatService
          .updateChat(this.hubName, this.currentChat, userContext)
          .subscribe(() => {
            // this.loadChats();
            this.showSuccess('Chat title updated successfully');
          });
      }
    }
  }

  updateFolder(folderId: string, newName: string, trigger?: MatMenuTrigger) {
    // Frontend validation
    if (!newName || newName.trim() === '') {
      return;
    }

    if (newName.length > 30) {
      this.showError('Trip name must be 30 characters or less');
      return;
    }

    // Allow only alphanumeric, spaces, and basic punctuation
    const validNameRegex = /^[a-zA-Z0-9\s\-_.,&+() ]+$/;
    if (!validNameRegex.test(newName)) {
      this.showError(
        'Trip name can only contain letters, numbers, spaces, and basic punctuation (-_.,&+())',
      );
      return;
    }

    const userContext = this.getUserContext();
    this.travelBuddyChatService
      .updateFolder(this.hubName, userContext.userId, folderId, newName.trim())
      .subscribe({
        next: () => {
          const folder = this.userChatFolders.find((f) => f._id === folderId);
          if (folder) {
            folder.name = newName.trim();
          }
          this.showSuccess('Trip updated successfully');
          trigger?.closeMenu();
        },
        error: (err) => {
          console.error('Error updating trip:', err);
          this.showError(err.error?.error || 'Failed to update trip');
        },
      });
  }

  // Load a saved chat with complete conversation history
  loadChat(chat: any) {
    // If user clicks the already-open chat, avoid rebuilding history.
    // Rebuilding during streaming may interrupt and duplicate output.
    const targetId = chat?.id;
    const currentId = this.currentChat?.id;
    const resolvedTargetId = this.chatIdAliases.get(targetId) || targetId;
    const resolvedCurrentId = this.chatIdAliases.get(currentId) || currentId;
    const isSameChat =
      !!targetId &&
      !!currentId &&
      (targetId === currentId ||
        resolvedTargetId === resolvedCurrentId ||
        this.chatIdAliases.get(targetId) === currentId ||
        this.chatIdAliases.get(currentId) === targetId);
    if (isSameChat) {
      return;
    }

    if (this.isWaitingForAIResponse) {
      this.isWaitingForAIResponse = false;
      this.aiResTextContent = '';
    }

    this.msgHistory = [];
    this.currentChat = chat;

    const hasMessages = chat?.messages?.length > 0;

    if (!hasMessages && chat?.id && !this.isAnonymous) {
      this.populateChatView(chat);
      this.cdRef.detectChanges();
      const userContext = this.getUserContext();
      if (userContext.userId) {
        this.travelBuddyChatService
          .getChatById(this.hubName, chat.id, userContext)
          .subscribe({
            next: (fullChat) => {
              if (fullChat?.messages?.length > 0) {
                chat.messages = fullChat.messages;
                const chatInList = this.recentChats.find((c) => c.id === chat.id);
                if (chatInList) {
                  chatInList.messages = fullChat.messages;
                }
                // Only render if this chat is still the active one
                if (this.currentChat?.id === chat.id) {
                  this.renderChatMessages(chat);
                }
              }
            },
            error: (error) => {
              console.error('Failed to fetch chat messages from API:', error);
            },
          });
      }
      return;
    }

    if (chat?.messages) {
      this.renderChatMessages(chat);
    }
  }

  private populateChatView(chat: any) {
    this.matchedPlaces = [];
    this.matchedEvents = [];
    this.welcomePageMapMarkers = [];
    this.isMapOpen = false;
    this.isDetailsOpen = false;
    if (this.isMobile) {
      this.isSidebarCollapsed = true;
    }
    this.currentChatTitle = chat.title;
    this.currentChatDate = chat.timestamp;
    this.isShowLandscreen = false;
    this.isInNormalChat = true;
    this.selectedAITrip = null;
  }

  private renderChatMessages(chat: any) {
    this.populateChatView(chat);

    let plainMsg = chat.messages;

    if (this.isUserLoggedIn) {
      plainMsg = [];
      for (let i = 0; i < chat.messages.length; i++) {
        const msg = chat.messages[i];
        const nextMsg = i + 1 < chat.messages.length ? chat.messages[i + 1] : null;

        if (msg.type === 'USER' && msg.msg) {
          const duplicatedByNextAi =
            nextMsg?.type === 'AI' &&
            !!nextMsg?.userQuery &&
            nextMsg.userQuery.trim() === msg.msg.trim();
          if (duplicatedByNextAi) {
            continue;
          }
          plainMsg.push({
            msg: msg.msg,
            type: 'USER',
            name: 'You',
            timestamp: msg.timestamp,
          });
          continue;
        }

        if (msg.userQuery) {
          plainMsg.push({
            msg: msg.userQuery,
            type: 'USER',
            name: 'You',
            timestamp: msg.timestamp,
          });
        }
        if (msg.msg && msg.type === 'AI' && plainMsg.last()?.type !== 'AI') {
          this.matchPlacesAndEvents(msg, true);
          plainMsg.push({
            msg: msg.msg,
            type: 'AI',
            name: msg.name,
            timestamp: msg.timestamp,
            placesMatched: this.matchedPlaces,
            eventsMatched: this.matchedEvents,
          });
        }
      }
    }
    this.msgHistory = plainMsg;
    this.restoreSuggestedPromptsForChat(chat?.id);

    this.cdRef.detectChanges();
    setTimeout(() => {
      // Reset scroll position to top first to prevent cut-off
      if (this.chatContainer) {
        this.chatContainer.nativeElement.scrollTop =
          this.chatContainer.nativeElement.scrollHeight;
      }
      this.restorePendingStreamForChat(chat?.id);
      this.selectedDateRange && this.dateRangePicker?.range.setValue(this.selectedDateRange);
    });
  }

  // Update the current chat with new messages
  updateCurrentChat() {
    console.log('---- recentChats', this.recentChats);
    if (!this.currentChat || this.recentChats.length === 0) return;

    const resolvedId = this.resolveChatId(this.currentChat.id);
    const chatIndex = this.recentChats.findIndex(
      (c) => c.id === this.currentChat.id || c.id === resolvedId,
    );

    if (chatIndex >= 0) {
      this.recentChats[chatIndex].messages = [...this.msgHistory];
      this.recentChats[chatIndex].timestamp = new Date();
      this.currentChat = this.recentChats[chatIndex];
      this.saveRecentChatsToStorage();
    }
  }

  // Delete a specific message from the current chat
  deleteMessage(messageId: string) {
    const actions: ConfirmModalActions = {
      confirm: (event: ButtonTriggerEvent) => {
        event.complete();

        // Find the index of the message to delete
        const messageIndex = this.msgHistory.findIndex((msg) => msg.id === messageId);

        if (messageIndex >= 0) {
          // Remove this message and all subsequent messages (to maintain conversation flow)
          this.msgHistory = this.msgHistory.slice(0, messageIndex);

          // Update the current chat
          this.updateCurrentChat();

          // Show success message
          this._snackBar.open('Message deleted successfully', 'Close', {
            duration: 3000,
            panelClass: ['success-snackbar'],
          });

          this.cdRef.detectChanges();
        }
      },
    };

    const data: ConfirmModalData = {
      confirmModalIcon: 'warning',
      confirmModalTitle: 'Delete Message',
      confirmModalDescription:
        'Are you sure you want to delete this message and all messages after it?',
      confirmModalConfirmButtonText: 'Yes',
      confirmModalCancelButtonText: 'No',
      isAsync: false,
    };

    this._modalService.show({
      component: ConfirmModalComponent,
      data: { data, actions },
    });
  }

  // Pin/unpin a chat (mark as recent)
  pinChat(chat: any, event: Event) {
    event.stopPropagation();
    chat.pinned = !chat.pinned;

    // Add pinnedAt timestamp when pinning, remove when unpinning
    if (chat.pinned) {
      chat.pinnedAt = new Date().toISOString();
    } else {
      delete chat.pinnedAt;
    }

    const userContext = this.getUserContext();

    // For guests, update localStorage
    if (this.isAnonymous || !userContext.userId) {
      console.log('Guest user - updating pin status in localStorage');
      // Re-sort to move pinned chats to top
      this.sortRecentChats();
      // Save to localStorage
      this.saveRecentChatsToLocalStorage();
      return;
    }

    // For logged-in users, update via API
    this.travelBuddyChatService
      .updateChat(this.hubName, { chatId: chat.id, isRecent: chat.pinned }, userContext)
      .subscribe({
        next: (updatedChat) => {
          console.log('Chat pinned status updated successfully:', updatedChat);
          // Update local state
          const index = this.recentChats.findIndex((c) => c.id === chat.id);
          if (index >= 0) {
            this.recentChats[index].pinned = updatedChat.isRecent || false;
            if (this.recentChats[index].pinned) {
              this.recentChats[index].pinnedAt = chat.pinnedAt;
            } else {
              delete this.recentChats[index].pinnedAt;
            }
          }
          // Re-sort to move pinned chats to top
          this.sortRecentChats();
        },
        error: (error) => {
          console.error('Failed to update chat pinned status:', error);
          // Revert the change on error
          chat.pinned = !chat.pinned;
          if (chat.pinned) {
            chat.pinnedAt = new Date().toISOString();
          } else {
            delete chat.pinnedAt;
          }
        },
      });
  }

  // Delete a chat
  deleteChat(chatId: string) {
    const chat = this.recentChats.find((x) => x.id === chatId);
    if (!chat) return;

    this.recentChats.splice(
      this.recentChats.findIndex((x) => x.id === chatId),
      1,
    );
    this.removeChatFromStorage(chatId);
    this.isShowLandscreen = true;
  }

  deleteFolder(folderId: string) {
    this.recentChats.splice(
      this.recentChats.findIndex((x) => x.id === folderId),
      1,
    );
    this.travelBuddyChatService.deleteFolder(this.hubName, this.userId, folderId).subscribe({
      next: (result) => {
        console.log('Trip deleted successfully:', result);
        this.userChatFolders = result.folders;
        this.assignChatToFolder();
        this.isShowLandscreen = true;
      },
      error: (error) => {
        console.error('Failed to delete folder:', error);
      },
    });
  }

  // Save chat to storage
  private saveChatToStorage(chat: any) {
    const chatData = {
      ...chat,
      messages: this.msgHistory,
      timestamp: new Date(),
    };

    if (this.isAnonymous) {
      // Guests: save to localStorage
      console.log('Guest user - saving chat to localStorage');
      const existingIndex = this.recentChats.findIndex((c) => c.id === chat.id);
      if (existingIndex >= 0) {
        this.recentChats[existingIndex] = chatData;
      } else {
        this.recentChats.unshift(chatData);
      }
      this.saveRecentChatsToLocalStorage();
    } else {
      // Logged-in users: save via API
      this.saveChatToUserAccount(chatData);
    }
  }

  // DEPRECATED: Old method that used localStorage - now using API exclusively
  private saveChatToLocalStorage(chat: any) {
    console.warn(
      'saveChatToLocalStorage is deprecated. Use API via saveChatToUserAccount instead.',
    );
  }

  // Save chat to user account (API call)
  private saveChatToUserAccount(chat: any) {
    console.log('Saving chat to user account:', chat);
    const userContext = this.getUserContext();

    const chatData = {
      title: chat.title,
      messages: this.travelBuddyChatService.convertMessages(chat.messages || []),
      isSaved: chat.saved,
    };

    this.travelBuddyChatService.saveChat(this.hubName, chatData, userContext).subscribe({
      next: (savedChat) => {
        console.log('Chat saved successfully:', savedChat);
        // Update local chat with server response
        const index = this.recentChats.findIndex((c) => c.id === chat.id);
        if (index >= 0) {
          this.recentChats[index] = {
            ...this.recentChats[index],
            id: savedChat.id,
            title: savedChat.title,
          };
        }
      },
      error: (error) => {
        console.error('Failed to save chat:', error);
      },
    });
  }

  // DEPRECATED: Old method that used localStorage - now using API exclusively
  private getSavedChatsFromLocalStorage(): any[] {
    console.warn('getSavedChatsFromLocalStorage is deprecated. Use API instead.');
    return [];
  }

  // Remove chat from storage
  private removeChatFromStorage(chatId: string) {
    if (this.isAnonymous) {
      // Guests: just remove from local array and update localStorage
      console.log('Guest user - removing chat from localStorage');
      this.recentChats = this.recentChats.filter((c) => c.id !== chatId);
      this.saveRecentChatsToLocalStorage();
    } else {
      // Logged-in users: remove via API
      this.removeChatFromUserAccount(chatId);
    }
  }

  // Remove chat from user account
  private removeChatFromUserAccount(chatId: string) {
    const userContext = this.getUserContext();

    // Check if we have valid user context for API call
    if (userContext.userId) {
      this.travelBuddyChatService.deleteChat(this.hubName, chatId, userContext).subscribe({
        next: () => {
          // Remove from local array
          this.recentChats = this.recentChats.filter((c) => c.id !== chatId);
          this.assignChatToFolder();
        },
        error: (error) => {
          console.error('Failed to delete chat:', error);
          // Still remove from local array even if API call fails
          this.recentChats = this.recentChats.filter((c) => c.id !== chatId);
          this.assignChatToFolder();
        },
      });
    } else {
      // For guests without valid IP, just remove from local array
      console.log('Guest without valid IP - removing chat locally only');
      this.recentChats = this.recentChats.filter((c) => c.id !== chatId);
    }
  }

  // Save recent chats to storage
  private saveRecentChatsToStorage() {
    if (this.isTransferringGuestChats) {
      return;
    }

    if (this.isAnonymous) {
      this.saveRecentChatsToLocalStorage();
    } else {
      this.saveRecentChatsToUserAccount();
    }
  }

  // Save recent chats to user account via API
  private saveRecentChatsToUserAccount() {
    if (this.isTransferringGuestChats) {
      return;
    }

    console.log('Saving recent chats via API:', this.recentChats);

    if (!this.currentChat) return;

    const resolvedId = this.resolveChatId(this.currentChat.id);
    let chat = this.recentChats.find(
      (c) => c.id === this.currentChat.id || c.id === resolvedId,
    ) || this.currentChat;

    const chatId = resolvedId || chat.id;
    if (chatId) {
      const userContext = this.getUserContext();
      const lastMessage = chat.messages?.last();

      if (!lastMessage) return;

      const lastUserMsg = chat.messages?.findLast((m) => m.type === 'USER');
      lastMessage.userQuery = lastUserMsg?.msg;
      lastMessage.placeSearch = (lastMessage.placeSearch || []).map((p) =>
        typeof p === 'string' ? p : p.name,
      );
      const updateData = {
        chatId: chatId,
        title: chat.title,
        messages: [lastMessage],
        isInsert: true,
        metadata: {
          lastMessageAt: new Date().toISOString(),
        },
      };

      // log updateData with color
      console.log('%cUpdate data:', 'color: orange', updateData);

      this.travelBuddyChatService
        .updateChat(this.hubName, updateData, userContext)
        .subscribe(() => {
          this.assignChatToFolder();
        });
    }
  }

  // Load recent chats from storage
  private loadRecentChatsFromStorage() {
    if (!this.isAnonymous) {
      // Logged-in users: load from API
      this.loadRecentChatsFromUserAccount();
    } else {
      // Guest users: load from localStorage
      this.loadRecentChatsFromLocalStorage();
    }
  }

  // Load guest chats from localStorage
  private loadRecentChatsFromLocalStorage() {
    console.log('Loading guest chats from localStorage');
    this.chatHistoryLoadId++;
    try {
      let storedChats: any = this._localStorage.getItem('travelbuddy_guest_recent_chats');

      // Handle cases where data was stored as a raw JSON string
      if (typeof storedChats === 'string') {
        try {
          storedChats = JSON.parse(storedChats);
        } catch (parseError) {
          console.error('Failed to parse guest chats string from localStorage:', parseError);
          storedChats = null;
        }
      }

      if (storedChats && Array.isArray(storedChats)) {
        this.recentChats = storedChats.map((chat: any) => ({
          ...chat,
          timestamp: new Date(chat.timestamp),
        }));
        console.log('Guest chats loaded from localStorage:', this.recentChats.length);
      } else {
        this.recentChats = [];
      }
    } catch (error) {
      console.error('Failed to load guest chats from localStorage:', error);
      this.recentChats = [];
    }

    // Mark as ready
    this.isUserChatHistoryReady = true;
    this.userChatHistoryReady.emit(true);
    this.cdRef.detectChanges();
  }

  // Save guest chats to localStorage
  private saveRecentChatsToLocalStorage() {
    console.log('Saving guest chats to localStorage');
    try {
      if (!this.isAnonymous && !this.isTransferringGuestChats) {
        console.warn('Skipping guest localStorage write while logged in');
        return;
      }
      const chatsToSave = this.recentChats || [];
      this._localStorage.setItem('travelbuddy_guest_recent_chats', chatsToSave);
      console.log('Guest chats saved to localStorage:', chatsToSave.length);
    } catch (error) {
      console.error('Failed to save guest chats to localStorage:', error);
    }
  }

  switchFolder(folder: any) {
    this.selectedFolder = folder;
    // this.loadFolderChats(folder);
  }

  selectFolder(folderId: string) {
    this.selectedFolderId = folderId;
  }

  setCurrentChat(chat: any): void {
    this.currentChat = chat;
    this.currentChatTitle = chat.title;
    if (this.currentChat.folderId) {
      this.selectFolder(this.currentChat.folderId);
    }
  }

  confirmMoveToFolder(folderId: string, event?: MouseEvent): void {
    if (event) {
      event.stopPropagation();
    }

    if (!this.userChatFolders.length) return;

    if (!this.currentChat) return;

    const resolvedChatId = this.resolveChatId(this.currentChat.id);

    const chatToMove = this.currentChat;
    const chatId = resolvedChatId || chatToMove.id;

    const userContext = this.getUserContext();
    this.travelBuddyChatService
      .moveChatToFolder(this.hubName, chatId, folderId, userContext)
      .subscribe({
        next: (data) => {
          console.log('Chat moved to folder:', data);
          chatToMove.folderId = folderId;
          const chatInList = this.recentChats.find(
            (c) => c.id === chatId || c.id === chatToMove.id,
          );
          if (chatInList && chatInList !== chatToMove) {
            chatInList.folderId = folderId;
          }
          this.showSuccess('Chat moved successfully');
          this.assignChatToFolder();
        },
        error: (error) => {
          console.error('Failed to move chat to folder:', error);
          this.showError('Failed to move chat. Please try again.');
        },
      });

    // Close the menu
    this.currentChatIndex = null;
  }

  getStandaloneChats() {
    return this.recentChats.filter((chat) => !chat.folderId);
  }

  private assignChatToFolder() {
    for (const folder of this.userChatFolders) {
      folder.chats = [];
      for (const chat of this.recentChats) {
        if (chat.folderId && chat.folderId === folder._id) {
          if (!folder.chats.some((c) => c.id === chat.id)) {
            folder.chats.push(chat);
          }
        }
      }
    }

    console.log('this.userChatFolders', this.userChatFolders);
  }

  createNewFolder(menuTrigger?: MatMenuTrigger) {
    // Trim whitespace
    this.newFolderName = this.newFolderName?.trim();

    // Validate folder name
    if (!this.newFolderName) {
      this.showError('Trip name cannot be empty');
      return;
    }

    // Check length
    if (this.newFolderName.length > 30) {
      this.showError('Trip name cannot exceed 30 characters');
      return;
    }

    // Check for invalid characters using same regex as backend
    const invalidChars = /[^a-zA-Z0-9\s\-\_.,&+()]/;
    if (invalidChars.test(this.newFolderName)) {
      this.showError(
        'Trip name can only contain letters, numbers, spaces, and these special characters: - _ . , & + ( )',
      );
      return;
    }

    const userContext = this.getUserContext();

    this.travelBuddyChatService
      .createFolder(this.hubName, { name: this.newFolderName }, userContext)
      .subscribe({
        next: (response) => {
          this.showSuccess('Trip created successfully');
          this.newFolderName = ''; // Clear the input
          menuTrigger?.closeMenu();
          this.loadUserChatFolders(); // Refresh the folder list
        },
        error: (error) => {
          console.error('Error creating trip:', error);
          this.showError(error.error?.message || 'Failed to create trip. Please try again.');
        },
      });
  }

  private loadUserChatFolders() {
    const userContext = this.getUserContext();
    this.travelBuddyChatService.getChatFolders(this.hubName, userContext).subscribe({
      next: (data) => {
        this.userChatFolders = data.folders || [];
        this.assignChatToFolder();
      },
      error: (error) => {
        console.error('Failed to load user chat folders:', error);
      },
    });
  }

  // Load recent chats from user account
  private loadRecentChatsFromUserAccount() {
    if (this.isLoadingUserChatHistory) {
      return;
    }

    const userContext = this.getUserContext();
    const loadId = ++this.chatHistoryLoadId;

    // Skip if user context is invalid (no userId)
    if (!userContext.userId) {
      if (!this.isAnonymous) {
        this.recentChats = [];
      }
      this.isUserChatHistoryReady = true;
      this.isLoadingUserChatHistory = false;
      this.userChatHistoryReady.emit(true);
      return;
    }

    this.isLoadingUserChatHistory = true;
    this.travelBuddyChatService
      .getRecentChats(this.hubName, userContext, 30)
      .pipe(
        finalize(() => {
          // to prevent login status changed trigger loading again
          timer(5000).subscribe(() => {
            this.isLoadingUserChatHistory = false;
          });
        }),
      )
      .subscribe({
        next: (chats) => {
          if (loadId !== this.chatHistoryLoadId || this.isAnonymous || !this.isUserLoggedIn) {
            return;
          }
          chats = chats.filter(
            (x) => x.messages.length > 0 && x.messages.some((y) => y.type === 'AI'),
          );
          this.recentChats = chats.map((chat: any) => {
            return {
              id: chat.id,
              title: chat.title,
              messages: chat.messages,
              timestamp: chat.metadata?.lastMessageAt || chat.updatedAt || chat.createdAt,
              rawCreatedAt: chat.createdAt,
              pinned: false,
              folderId: chat.folderId,
              metadata: chat.metadata,
            };
          });

          this.sortRecentChats();

          if (this.guestTransferStartTime > 0) {
            const startTime = this.guestTransferStartTime;
            this.guestTransferStartTime = 0;
            const transferred = this.recentChats.filter(
              (c) => c.rawCreatedAt && new Date(c.rawCreatedAt).getTime() >= startTime - 30000,
            );
            if (transferred.length > 0) {
              transferred.forEach((c) => this.newlyTransferredChatIds.add(c.id));
              setTimeout(() => {
                this.newlyTransferredChatIds.clear();
                this.cdRef.detectChanges();
              }, 2000);
            }

            if (
              this.currentChat &&
              this.currentChat.id?.startsWith('chat_') &&
              transferred.length > 0
            ) {
              // Match by title (the first user message) since IDs change during transfer
              const matchedChat = transferred.find(
                (c) => c.title === this.currentChat.title,
              );
              if (matchedChat) {
                // Count server-side AI messages before overwriting with local history
                const serverAiCount = (matchedChat.messages || []).filter(
                  (m: any) => m.type === 'AI',
                ).length;
                const localAiCount = this.msgHistory.filter(
                  (m) => m.type === 'AI',
                ).length;

                this.chatIdAliases.set(this.currentChat.id, matchedChat.id);
                matchedChat.messages = [...this.msgHistory];
                this.currentChat = matchedChat;

                if (localAiCount > serverAiCount) {
                  this.saveRecentChatsToUserAccount();
                }
              }
            }
          }

          // Mark chat history as ready so the icon appears
          this.isUserChatHistoryReady = true;
          this.cdRef.detectChanges();
          this.userChatHistoryReady.emit(true);

          this.loadUserChatFolders();
        },
        error: (error) => {
          console.error('Failed to load recent chats:', error);
          if (loadId !== this.chatHistoryLoadId || this.isAnonymous || !this.isUserLoggedIn) {
            return;
          }
          this.recentChats = [];
          // Still mark as ready even on error, so icon shows
          this.isUserChatHistoryReady = true;
          this.isLoadingUserChatHistory = false;
          this.userChatHistoryReady.emit(true);
        },
      });
  }

  // Sort recent chats: pinned first (most recently pinned at top), then by timestamp
  private sortRecentChats() {
    this.recentChats.sort((a, b) => {
      // Pinned chats come first
      if (a.pinned && !b.pinned) return -1;
      if (!a.pinned && b.pinned) return 1;

      // If both are pinned, sort by pinnedAt timestamp (most recently pinned first)
      if (a.pinned && b.pinned) {
        const pinnedTimeA = a.pinnedAt ? new Date(a.pinnedAt).getTime() : 0;
        const pinnedTimeB = b.pinnedAt ? new Date(b.pinnedAt).getTime() : 0;
        return pinnedTimeB - pinnedTimeA;
      }

      // For unpinned chats, sort by timestamp (most recent first)
      const timeA = new Date(a.timestamp).getTime();
      const timeB = new Date(b.timestamp).getTime();
      return timeB - timeA;
    });
  }

  // Add new chat to recent chats with complete conversation history
  private addToRecentChats(title: string, messages: any[]) {
    const userContext = this.getUserContext();
    const tempChatId = this.generateChatId();

    if (this.isAnonymous || this.isTransferringGuestChats || !userContext.userId) {
      console.log('Saving guest chat to localStorage');
      const newChat = {
        id: tempChatId,
        title: title,
        messages: [...messages],
        timestamp: new Date(),
      };

      // Add to beginning of array
      this.recentChats.unshift(newChat);
      this.currentChat = newChat;

      // Sort to ensure pinned chats stay at top
      this.sortRecentChats();

      // Save to localStorage
      this.saveRecentChatsToLocalStorage();

      // Update current chat title and date
      this.currentChatTitle = title;
      this.currentChatDate = new Date();
      return;
    }

    // Create chat data for API
    const optimisticChat = {
      id: tempChatId,
      title: title,
      messages: [...messages],
      timestamp: new Date(),
      metadata: {
        lastMessageAt: new Date().toISOString(),
      },
    };
    this.recentChats.unshift(optimisticChat);
    this.currentChat = optimisticChat;
    this.sortRecentChats();

    const chatData = {
      title: title,
      messages: this.travelBuddyChatService.convertMessages(messages),
      isSaved: false,
      metadata: {
        lastMessageAt: new Date().toISOString(),
      },
    };

    // Save to API for logged-in users only
    this.travelBuddyChatService.saveChat(this.hubName, chatData, userContext).subscribe({
      next: (savedChat) => {
        console.log('New chat saved successfully via API:', savedChat);
        const index = this.recentChats.findIndex((c) => c.id === tempChatId);
        if (index >= 0) {
          this.chatIdAliases.set(tempChatId, savedChat.id);
          if (this.pendingStreamByChatId.has(tempChatId)) {
            const pending = this.pendingStreamByChatId.get(tempChatId);
            if (pending) {
              this.pendingStreamByChatId.set(savedChat.id, pending);
            }
          }
          if (this.suggestedPromptsByChatId.has(tempChatId)) {
            const prompts = this.suggestedPromptsByChatId.get(tempChatId);
            if (prompts) {
              this.suggestedPromptsByChatId.set(savedChat.id, prompts);
            }
          }
          this.recentChats[index] = {
            ...this.recentChats[index],
            id: savedChat.id,
            title: savedChat.title,
            timestamp: savedChat.createdAt || new Date(),
            metadata: savedChat.metadata,
          };
          if (this.currentChat?.id === tempChatId) {
            this.currentChat = this.recentChats[index];
          }
          const savedMsgCount = (savedChat.messages || []).length;
          const currentAiCount = this.recentChats[index].messages?.filter(
            (m) => m.type === 'AI',
          ).length || 0;
          if (currentAiCount > savedMsgCount && this.currentChat?.id === savedChat.id) {
            this.saveRecentChatsToUserAccount();
          }
        }
        this.sortRecentChats();

        // Update current chat title and date
        this.currentChatTitle = title;
        this.currentChatDate = new Date();
      },
      error: (error) => {
        console.error('Failed to save new chat via API:', error);
        // Keep optimistic chat in UI if API save failed.
        this.sortRecentChats();
        this.currentChatTitle = title;
        this.currentChatDate = new Date();
      },
    });
  }

  showUpdateChatTitleMenu() {
    this.isShowUpdateChatTitle = true;
    this.cdRef.detectChanges();
  }

  showMoveChatMenu() {
    this.isShowUpdateChatTitle = false;
    this.cdRef.detectChanges();
  }

  // Generate unique chat ID
  private generateChatId(): string {
    return 'chat_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
  }

  // Handle copy response
  handleCopyResponse(message: any) {
    const textContent = this.stripHtml(message.msg);
    navigator.clipboard
      .writeText(textContent)
      .then(() => {
        // Show success message
        console.log('Response copied to clipboard');
        this._snackBar.open('Response copied to clipboard', 'Close', {
          duration: 2000,
          horizontalPosition: 'center',
          verticalPosition: 'bottom',
        });
      })
      .catch((err) => {
        console.error('Failed to copy text: ', err);
      });
  }

  // Handle share response
  handleShareResponse(message: any) {
    const textContent = this.stripHtml(message.msg);

    if (navigator.share) {
      navigator
        .share({
          title: 'AI TravelBuddy Response',
          text: textContent,
          url: window.location.href,
        })
        .catch((err) => {
          console.error('Error sharing: ', err);
          this.fallbackShare(textContent);
        });
    } else {
      this.fallbackShare(textContent);
    }
  }

  // Handle save for later
  handleSaveForLater(message: any) {
    console.log('Saving message for later:', message);

    // Save the current chat with this message marked
    if (this.recentChats.length > 0) {
      const currentChat = this.recentChats[0];

      const userContext = this.getUserContext();
      this.travelBuddyChatService
        .toggleChatSaved(this.hubName, currentChat.id, true, userContext)
        .subscribe({
          next: () => {
            this._snackBar.open('Saved for later!', 'Close', {
              duration: 2000,
              horizontalPosition: 'center',
              verticalPosition: 'bottom',
            });
          },
          error: (error) => {
            console.error('Failed to save message:', error);
            this._snackBar.open('Failed to save message', 'Close', {
              duration: 2000,
              horizontalPosition: 'center',
              verticalPosition: 'bottom',
            });
          },
        });
    }
  }

  // Handle like response
  handleLikeResponse(message: any) {
    console.log('Liked response:', message);
    // TODO: Implement like functionality (send to API for analytics)
    this._snackBar.open('Thanks for your feedback!', 'Close', {
      duration: 2000,
      horizontalPosition: 'center',
      verticalPosition: 'bottom',
    });
  }

  // Handle dislike response
  handleDislikeResponse(message: any) {
    console.log('Disliked response:', message);
    // TODO: Implement dislike functionality (send to API for analytics)
    this._snackBar.open("Thanks for your feedback. We'll improve!", 'Close', {
      duration: 2000,
      horizontalPosition: 'center',
      verticalPosition: 'bottom',
    });
  }

  // Handle regenerate response
  handleRegenerateResponse(message: any) {
    console.log('Regenerating response for:', message);
    // Find the last user message before this AI message and resend it
    const lastUserMsg = this.msgHistory?.filter((x) => x.type === 'USER')?.last()?.msg;
    if (lastUserMsg) {
      this.onTryAgain.emit(lastUserMsg);
    }
  }

  // Handle feedback (good/bad)
  handleFeedback(event: { message: any; feedback: 'good' | 'bad' }) {
    const { message, feedback } = event;
    console.log('Feedback received:', feedback, 'for message:', message);

    if (feedback === 'good') {
      // Good feedback - send positive response, no additional action needed
      this._snackBar.open('Thanks for your positive feedback!', 'Close', {
        duration: 2000,
        horizontalPosition: 'center',
        verticalPosition: 'bottom',
        panelClass: ['success-snackbar'],
      });

      // TODO: Send feedback to API for analytics
      // this._visitorService.sendFeedback(message.id, 'good').subscribe();
    } else if (feedback === 'bad') {
      // Bad feedback - try again with a different approach
      this._snackBar.open("We'll try a different approach!", 'Close', {
        duration: 2000,
        horizontalPosition: 'center',
        verticalPosition: 'bottom',
        panelClass: ['warning-snackbar'],
      });

      // Find the last user message and regenerate with different approach
      const lastUserMsg = this.msgHistory?.filter((x) => x.type === 'USER')?.last()?.msg;
      if (lastUserMsg) {
        // Add a flag to indicate we want a different approach
        const modifiedMessage = `${lastUserMsg} (Please provide a different approach or perspective)`;
        this.onTryAgain.emit(modifiedMessage);
      }

      // TODO: Send feedback to API for analytics
      // this._visitorService.sendFeedback(message.id, 'bad').subscribe();
    }
  }

  // Handle message editing
  handleEditMessage(message: ITravelAssistantMessage) {
    console.log('Edit message:', message);

    // Find the index of this message in history
    const messageIndex = this.msgHistory.findIndex((m) => m.id === message.id);
    if (messageIndex === -1) return;

    // Cancel ongoing AI response if any
    if (this.isWaitingForAIResponse) {
      this.isWaitingForAIResponse = false;
      this.activeSseSubscription?.unsubscribe();
      this.activeSseSubscription = undefined;
      this.activeStreamToken = null;
      this.aiResTextContent = '';
      // Remove stale pending stream data so restorePendingStreamForChat
      // won't replay a partial response when this chat is reopened
      if (this.currentChat?.id) {
        this.pendingStreamByChatId.delete(this.currentChat.id);
        const resolvedId = this.resolveChatId(this.currentChat.id);
        if (resolvedId && resolvedId !== this.currentChat.id) {
          this.pendingStreamByChatId.delete(resolvedId);
        }
      }
    }

    // Remove all messages after this one (including AI responses)
    this.msgHistory = this.msgHistory.slice(0, messageIndex + 1);

    // Set the message text in the input field
    this.msg = message.msg;

    // Focus on the input field
    requestAnimationFrame(() => {
      const inputElement = document.querySelector('.ig-im-msg-box textarea') as HTMLTextAreaElement;
      if (inputElement) {
        inputElement.focus();
        // Place cursor at the end
        inputElement.setSelectionRange(inputElement.value.length, inputElement.value.length);
      }
    });

    // Show notification
    this._snackBar.open('Message loaded for editing. Click send to submit.', 'Close', {
      duration: 3000,
      horizontalPosition: 'center',
      verticalPosition: 'bottom',
      panelClass: ['info-snackbar'],
    });

    // Update UI
    this.cdRef.detectChanges();
    this.scrollToBottom();
  }

  // Handle message deletion
  handleDeleteMessage(message: ITravelAssistantMessage) {
    if (message.id) {
      this.deleteMessage(message.id);
    }
  }

  // DEPRECATED: Old method that used localStorage - now using API exclusively
  private getSavedMessages(): any[] {
    console.warn('getSavedMessages is deprecated. Use API instead.');
    return [];
  }

  // Generate unique message ID
  private generateMessageId(): string {
    return 'msg_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
  }

  // Strip HTML tags from content
  private stripHtml(html: string): string {
    const tmp = document.createElement('div');
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || '';
  }

  // Fallback share method
  private fallbackShare(text: string) {
    const textArea = document.createElement('textarea');
    textArea.value = text;
    document.body.appendChild(textArea);
    textArea.select();
    document.execCommand('copy');
    document.body.removeChild(textArea);
    console.log('Response copied to clipboard (fallback)');
  }

  private displayUserChatHistory() {
    if (this.userChatHistory.length) {
      if (!this.msgHistory) {
        this.msgHistory = [];
      }

      const day = [];

      for (const msg of this.userChatHistory) {
        const dateStr = new Date(msg.createdAt).toLocaleDateString();
        if (!day.includes(dateStr)) {
          day.push(dateStr);

          this.msgHistory.push({
            msg: dateStr,
            type: 'DATETIME',
            name: '',
            questions: [],
          });
        }

        this.msgHistory.push({
          msg: msg.conversation.user,
          type: 'USER',
          name: 'Me',
          questions: [],
        });
        const processed = window['marked'].parse(msg.conversation.ai);
        this.msgHistory.push({
          msg: processed,
          type: 'AI',
          name: this.travelBuddySettings.ui.avatar.name,
          questions: [],
        });
      }

      this.isShowLandscreen = false;
      this.isInNormalChat = true;
      this.cdRef.detectChanges();
      setTimeout(() => {
        this.scrollToBottom(0, true); // Force scroll when displaying chat history
        this.userProfilePicture = this.userFromStorage?.avatar;
        this.selectedDateRange && this.dateRangePicker?.range.setValue(this.selectedDateRange);
      });
    }
  }

  buildStepShowing(index: number) {
    if (index < 10) {
      // Reduced from 50ms to 20ms for faster stagger effect
      setTimeout(() => {
        this.showLandscreenContent[index] = true;
        this.buildStepShowing(++index);
      }, 20);
    }
  }

  resetStepShowing() {
    for (let i = 0; i < 10; i++) {
      this.showLandscreenContent[i] = false;
    }
  }

  expandScreen() {
    this.isScreenExpanded = !this.isScreenExpanded;
    this.onExpandScreen.emit(this.isScreenExpanded);
  }

  // get isUserLoggedIn() {
  //   // Check social login first
  //   if (SocialLoginComponent.isUserLoggedIn) {
  //     return true;
  //   }

  //   // Check if user has email (regular login)
  //   if (this.userEmail && this.userEmail.trim()) {
  //     return true;
  //   }

  //   // Check if user is not anonymous
  //   // if (!this.isAnonymous) {
  //   //   return false;
  //   // }

  //   return false;
  // }

  get userId() {
    return SocialLoginComponent.userId || this.userEmail;
  }

  get userSocialName() {
    return SocialLoginComponent.isUserLoggedIn
      ? SocialLoginComponent.socialName
      : this.userEmail
        ? 'email'
        : '';
  }

  emailKeypress($event: KeyboardEvent) {
    if ($event.key === 'Enter') {
      this.gotoChatWithEmail();
    }
  }

  gotoChatWithEmail() {
    const email = this.emailInput || this.form.get('email')?.value;
    console.log('email', email);

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!email || !emailRegex.test(email)) {
      this.emailErrorMsg = `Please enter a valid email address.`;
      return;
    }

    this.emailErrorMsg = '';
    this.isAppendLoginToChatArea = false;
    this.isAnonymous = false;

    this.userEmail = email;
    this._localStorage.setItem('travelbuddy_user_email', email);
    this.isAnonymous = false;
    this.closeLoginPopup();
    // this.updateUserInfo();
    this.loginStatusChanged(true);
  }

  async gotoChat(msg: string, isTryAgain = false, process?: (data: IAIResponse) => IAIResponse) {
    if (!msg && !isTryAgain) {
      return;
    }

    this.isShowLandscreen = false;
    this.isUseWelcomeLandscreen = false;
    this.isInNormalChat = true; // Ensure we're in normal chat mode
    this.addScrollingEvent();

    this.customProcessor = process || this.answerProcessor;

    // Replace target placeholder and add context from filters
    let processedMsg = msg?.replace('{{target}}', this.target);

    // Automatically append date and preference context if filters are active
    // Only add if the message doesn't already have context (not coming from sendQuestionWithContext)
    if (
      processedMsg &&
      !processedMsg.includes('(Preferences:') &&
      !processedMsg.includes('(Date:')
    ) {
      if (this.selectedPreferences.length > 0) {
        const preferenceNames = this.selectedPreferences.map((_id) => {
          const pref = this.tripPreferences.find((p) => p._id === _id);
          return pref ? pref.name : _id;
        });
        processedMsg += ` (Preferences: ${preferenceNames.join(', ')})`;
      }

      if (this.selectedDateRange && !processedMsg.includes('Planned dates')) {
        processedMsg += ` (Planned dates: ${this.formatDateForDisplay(
          this.selectedDateRange.start,
        )} - ${this.formatDateForDisplay(this.selectedDateRange.end)})`;
      } else if (this.isFlexibleDates) {
        // processedMsg += ` (Flexible dates)`;
      }
    }

    this.msg = processedMsg;

    this.userEmail = this._localStorage.getItem('travelbuddy_user_email') || undefined;

    // REMOVED: Don't show login popup when starting conversation - per Aline's feedback
    // Users should be able to chat freely without being prompted to sign in
    // They can choose to sign in later if they want to save their trips
    // if (!this.isUserLoggedIn && !this.isAnonymous) {
    //   this.showLoginPopup();
    //   return;
    // }

    this.userProfilePicture = SocialLoginComponent.profilePicture;
    this.isShowLogin = false;

    // Ensure header is visible by triggering change detection
    this.cdRef.detectChanges();

    setTimeout(() => {
      this.selectedDateRange && this.dateRangePicker?.range.setValue(this.selectedDateRange);
    });

    await this.send(false);
  }

  async send(isAfterLogin: boolean) {
    if (this.isWaitingForAIResponse) return;

    // question = question from suggestions, this.msg = user input question, this.msgHistory.last() = last user question, for retrying
    this.msg = this.msg || this.msgHistory?.filter((x) => x.type === 'USER')?.last()?.msg;
    if (!this.msg) return;

    this.tryAutoOpenSidebarForGuestFirstQuestion();

    const history = this.msgHistory
      ?.filter((x) => x.type !== 'AI_ERROR')
      // .slice(1)
      .map((item) => {
        const type = item.type;
        return {
          msg: item.msg,
          type,
        };
      });

    this.isAskingAfterLogin = isAfterLogin;

    this.createMsg({
      msg: this.msg,
      type: 'USER',
    } as ITravelAssistantMessage);

    this.askAI(isAfterLogin);

    this.msg = '';
  }

  private tryAutoOpenSidebarForGuestFirstQuestion() {
    if (this.isUserLoggedIn || this.hasAutoOpenedSidebarForGuest || this.isMobile) {
      return;
    }

    this.hasAutoOpenedSidebarForGuest = true;

    if (!this.isSidebarCollapsed) {
      return;
    }

    this.isSidebarCollapsed = false;
    this.isMapOpen = false;
    this.isDetailsOpen = false;
  }

  keypress($event: KeyboardEvent) {
    // Handle Enter key without modifiers - send message
    // Shift+Enter or Cmd+Enter - insert new line (browser default)
    if ($event.key === 'Enter' && !$event.shiftKey && !$event.metaKey && !$event.ctrlKey) {
      $event.preventDefault(); // Prevent default Enter behavior (new line)
      if (this.msg && this.msg.trim()) {
        this.onSendClick.emit(this.msg);
      }
    }
    // If Shift+Enter or Cmd/Ctrl+Enter, allow default behavior (new line)
  }

  // Auto-resize textarea as user types
  autoResize(event: any) {
    const textarea = event.target;
    textarea.style.height = 'auto'; // Reset height
    const newHeight = Math.min(textarea.scrollHeight, 150); // Max height 150px
    textarea.style.height = newHeight + 'px';
  }

  scrollToTop() {
    // Use requestAnimationFrame instead of 10ms setTimeout
    requestAnimationFrame(() => {
      this.container &&
        this.container.nativeElement.scrollTo({
          top: 0,
        });
      this.isInNormalChat &&
        this.chatContainer &&
        this.chatContainer.nativeElement.scrollTo({
          top: 0,
        });
      this.cdRef.detectChanges();
    });
  }

  scrollFeaturedPlacesToTop(container: HTMLElement): void {
    if (!container) return;
    container.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }

  scrollToBottom(timeout = 0, force = false) {
    // Use requestAnimationFrame instead of setTimeout - ignore timeout parameter for now
    requestAnimationFrame(() => {
      // Check if user is already near the bottom before auto-scrolling
      // This prevents annoying auto-scroll during long AI responses
      const shouldScroll = force || this.isUserNearBottom();

      if (shouldScroll) {
        this.container &&
          this.container.nativeElement.scrollTo({
            top: this.container.nativeElement.scrollHeight,
          });
        this.isInNormalChat &&
          this.chatContainer &&
          this.chatContainer.nativeElement.scrollTo({
            top: this.chatContainer.nativeElement.scrollHeight,
          });
      }
      this.cdRef.detectChanges();
    });
  }

  // Helper method to check if user is near the bottom of the chat
  private isUserNearBottom(threshold = 100): boolean {
    if (this.isInNormalChat && this.chatContainer) {
      const element = this.chatContainer.nativeElement;
      const scrollPosition = element.scrollTop + element.clientHeight;
      const scrollHeight = element.scrollHeight;
      return scrollHeight - scrollPosition < threshold;
    }
    if (this.container) {
      const element = this.container.nativeElement;
      const scrollPosition = element.scrollTop + element.clientHeight;
      const scrollHeight = element.scrollHeight;
      return scrollHeight - scrollPosition < threshold;
    }
    return true; // Default to true if no container
  }

  addScrollingEvent(): void {
    if (this.isInNormalChat) {
      requestAnimationFrame(() => {
        fromEvent(this.chatContainer.nativeElement, 'scroll')
          .pipe(
            debounceTime(10),
            tap((e) => {
              const { scrollTop, scrollHeight, clientHeight } = this.chatContainer.nativeElement;
              // calculate if is scrolled to bottom using scrollTop, scrollHeight, clientHeight
              // if user logout with social accounts,  when scrolling to bottom, show login box
              if (scrollHeight - scrollTop < clientHeight + 60) {
                this.isAtbottom = true;
                this.cdRef.detectChanges();
              } else {
                this.isAtbottom = false;
                this.cdRef.detectChanges();
              }
            }),
          )
          .subscribe();
      });
    }
  }

  disableScroll() {
    // Use requestAnimationFrame instead of 1000ms setTimeout
    requestAnimationFrame(() => {
      this.isInNormalChat &&
        this.chatContainer &&
        this.chatContainer.nativeElement.classList.add('overflow-y-hidden');
      this.cdRef.detectChanges();
    });
  }

  enableScroll() {
    // Use requestAnimationFrame instead of setTimeout
    requestAnimationFrame(() => {
      this.isInNormalChat &&
        this.chatContainer &&
        this.chatContainer.nativeElement.classList.remove('overflow-y-hidden');
      // to hide the login box and update view
      this.cdRef.detectChanges();
    });
  }

  createMsg(msg: ITravelAssistantMessage): void {
    console.log('---------------------createMsg called with-------------------', msg);

    if (isNullOrUndefined(this.msgHistory)) {
      this.msgHistory = [];
    }

    if (msg.type === 'AI_THINKING') {
      this.msgHistory.push({
        msg: '',
        type: msg.type,
        name: this.travelBuddySettings.ui.avatar.name,
        questions: [],
      });
      this.scrollToBottom(0, true); // Force scroll when adding AI thinking message
      return;
    }

    // a non-ai-thinking message, remove previous ai-thinkings
    if (this.msgHistory.last()?.type === 'AI_THINKING') {
      this.msgHistory = this.msgHistory.slice(0, this.msgHistory.length - 1);
    }

    const messageData: ITravelAssistantMessage = {
      msg: msg.msg,
      type: msg.type,
      name: msg.type === 'USER' ? 'You' : this.travelBuddySettings.ui.avatar.name,
      model: msg.model,
      questions: msg.questions,
      timeConsumed: msg.timeConsumed,
      id: msg.id || this.generateMessageId(),
      placesMentioned: msg.placesMentioned,
      placeSearch: msg.placeSearch,
      // placeInList: msg.placeInList,
      eventsMentioned: msg.eventsMentioned,
      askForEvents: msg.askForEvents,
      askForItinerary: msg.askForItinerary,
      timestamp: msg.timestamp || new Date(), // Add timestamp
      isEditable: msg.type === 'USER', // User messages are editable
      summary: msg.summary,
      totalSystemPromptTime: msg.totalSystemPromptTime,
      timeToFirstChunk: msg.timeToFirstChunk,
      toolCalls: msg.toolCalls,
    };

    this.msgHistory.push(messageData);

    // Reset markers for every AI response and match places if mentioned
    if (msg.type === 'AI') {
      // Always reset markers and route state for new AI response
      this.resetMapState();

      // Match places with real data if places are mentioned
      if (msg.placesMentioned?.length > 0 || msg.eventsMentioned?.length > 0) {
        this.matchPlacesAndEvents(msg);

        // Open map and fit bounds immediately using requestAnimationFrame for smooth DOM updates
        // this.isMapOpen = true;
        // console.log('isMapOpen 1');
        this.cdRef.detectChanges();

        // Use requestAnimationFrame for proper timing with DOM rendering
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            this.googleMap?.fitBounds();
          });
        });
      }
    }

    // If this is the first user message, add to recent chats
    if (msg.type === 'USER' && this.msgHistory.filter((m) => m.type === 'USER').length === 1) {
      // const chatTitle = msg.msg.length > 50 ? msg.msg.substring(0, 50) + '...' : msg.msg;
      this.addToRecentChats(msg.msg, [...this.msgHistory]);
    } else if (msg.type === 'AI') {
      // Update the current chat with the new message
      this.updateCurrentChat();
    }

    this.scrollToBottom(0, true); // Force scroll when user sends a message
    this.checkHasScrollbar();

    console.log('---------------------Emitting onMsgCreated with-------------------', {
      lastMsg: msg,
      placeSearch: msg.placeSearch,
      placesMentioned: msg.placesMentioned,
      eventsMentioned: msg.eventsMentioned,
      askForEvents: msg.askForEvents,
      askForItinerary: msg.askForItinerary,
    });

    this.onMsgCreated.emit({
      lastMsg: msg,
      placeSearch: msg.placeSearch,
      placesMentioned: msg.placesMentioned,
      eventsMentioned: msg.eventsMentioned,
      askForEvents: msg.askForEvents,
      askForItinerary: msg.askForItinerary,
      summary: msg.summary,
      timeConsumed: msg.timeConsumed,
      totalSystemPromptTime: msg.totalSystemPromptTime,
      timeToFirstChunk: msg.timeToFirstChunk,
      toolCalls: msg.toolCalls,
    });
  }

  extractChatHistory(messages: any[], maxRounds = 5) {
    const pairs = [];

    for (let i = messages.length - 1; i >= 0; i--) {
      const msg = messages[i];
      if (msg.type === 'AI') {
        if (!msg.userQuery && i - 1 >= 0 && messages[i - 1].type === 'USER') {
          msg.userQuery = messages[i - 1].msg;
        }
        pairs.push({
          user: msg.userQuery,
          ai: msg.summary || msg.msg || '',
        });

        if (pairs.length >= maxRounds) break;
      }
    }

    pairs.reverse();
    const chatMessages = [];
    pairs.forEach((p) => {
      chatMessages.push({ role: 'user', content: p.user });
      chatMessages.push({ role: 'assistant', content: p.ai });
    });

    return chatMessages;
  }

  async askAI(isAfterLogin: boolean) {
    this.isWaitingForAIResponse = true;
    this.suggestedPrompts = [];
    this.isMapOpen = false;
    this.isMappingData = false;
    this.chatContainer.nativeElement.scrollTop = this.chatContainer.nativeElement.scrollHeight;

    // Create initial AI_THINKING message for streaming
    this.createMsg({
      msg: '',
      type: 'AI_THINKING',
      questions: [],
    } as ITravelAssistantMessage);

    const uid = this.userId || this.generateUserId();

    console.log(
      '%c ---------------------askAI called with-------------------',
      'color: red',
      this.msgHistory,
    );
    const context = this.extractChatHistory(this.msgHistory);
    console.log('context', context);
    const streamChatId = this.currentChat?.id || null;
    const streamToken = guid();
    this.activeStreamToken = streamToken;
    if (streamChatId) {
      this.pendingStreamByChatId.set(streamChatId, {
        fullResponse: '',
        hasMetadata: false,
        hasToolCall: false,
      });
    }

    // this.placeService.getDestinationPlaceFeeds(this.hubName).subscribe((places) => {
    //   this.allPlaces = places;
    //   console.log('%creload all places in immessage.box', 'color: yellow', places.length);
    // });

    this.activeSseSubscription?.unsubscribe();
    this.activeSseSubscription = this._visitorService
      .travelBuddyConversationStreamSSE({
        hubName: this.hubName,
        question: this.msg,
        // assistantId: this.assistantId,
        // threadId: this.threadId,
        userId: uid,
        isAnonymous: this.isAnonymous,
        // userImg: SocialLoginComponent.profilePicture,
        userEmail: SocialLoginComponent.email || this.userEmail,
        socialName: this.userSocialName,
        userName: SocialLoginComponent.userName,
        cityName: this.travelBuddySettings.cityName,
        // isAllowTrackingChat: this.isAskingAfterLogin ? this.isAllowTrackingChat : undefined,
        context,
        isCheckPlaceStatusInAdvance: this.isCheckPlaceStatusInAdvance,
        _v: Date.now().toString(),
      })
      .pipe(
        catchError((err) => {
          console.error('Error in travelBuddyConversationStreamSSE:', err);
          console.log('msgHistory', this.msgHistory);
          if (
            this.canRenderStreamForChat(streamChatId, streamToken) &&
            this.msgHistory?.last()?.type !== 'AI_ERROR'
          ) {
            this.createMsg({ type: 'AI_ERROR' } as ITravelAssistantMessage);
          }
          this.isWaitingForAIResponse = false;
          return of();
        }),
      )
      .subscribe((evt) => {
        if (this.activeStreamToken !== streamToken) return;

        if (evt.type === 'message') {
          this.aiResTextContent = evt.fullResponse || evt.content || '';
          this.cachePendingStream(streamChatId, this.aiResTextContent);
          if (this.canRenderStreamForChat(streamChatId, streamToken)) {
            this.renderStreamResponseToView(this.aiResTextContent);
          }
        }

        if (evt.type === 'complete') {
          this.isWaitingForAIResponse = false;
          const data = evt.data || {};
          this.isMappingData = false;

          console.log('%c SSE complete', 'color: yellow', data);

          try {
            let processed = this.processMsg({
              answer: data.answer,
              placeInList: data.placeInList || [],
              placeSearch: data.placeSearch || [],
              placesMentioned: data.placesMentioned || [],
              eventsMentioned: data.eventsMentioned || [],
              eventsIds: data.eventsIds || [],
              askForEvents: !!data.askForEvents,
              askForItinerary: !!data.askForItinerary,
              questions: data.questions || [],
              summary: data.summary || '',
              totalSystemPromptTime: data.totalSystemPromptTime || 0,
              timeToFirstChunk: data.timeToFirstChunk || 0,
              toolCalls: data.toolCalls || [],
            } as IAIResponse);

            if (this.customProcessor) {
              processed = this.customProcessor(processed);
            }

            if (data.assistantId) this.assistantId = data.assistantId;
            if (data.threadId) this.threadId = data.threadId;

            // Update suggested prompts with cleaned questions from the response
            if (processed.questions && Array.isArray(processed.questions)) {
              const nextPrompts = this.normalizeSuggestedPrompts(processed.questions);
              const resolvedStreamChatId = this.resolveChatId(streamChatId);
              if (resolvedStreamChatId) {
                this.suggestedPromptsByChatId.set(resolvedStreamChatId, nextPrompts);
              }
              if (this.canRenderStreamForChat(streamChatId, streamToken)) {
                this.suggestedPrompts = nextPrompts;
                console.log('=== SSE Flow: suggestedPrompts updated ===', this.suggestedPrompts);
              }
            }

            const finalAiMessage = {
              msg: processed.answer,
              type: 'AI',
              questions: processed.questions?.length ? processed.questions : ['Please tell more'],
              timeConsumed: data.timeConsumed || 0,
              placeSearch: processed.placeSearch,
              placeInList: processed.placeInList,
              placesMentioned: processed.placesMentioned,
              eventsMentioned: processed.eventsMentioned,
              eventsIds: processed.eventsIds,
              askForEvents: processed.askForEvents,
              askForItinerary: processed.askForItinerary,
              summary: processed.summary || '',
              totalSystemPromptTime: processed.totalSystemPromptTime || 0,
              timeToFirstChunk: processed.timeToFirstChunk || 0,
              toolCalls: processed.toolCalls || [],
            } as ITravelAssistantMessage;

            if (this.canRenderStreamForChat(streamChatId, streamToken)) {
              this.createMsg(finalAiMessage);
            } else {
              this.appendAiMessageToChat(streamChatId, finalAiMessage);
            }

            this.isMappingData = false;

            // use colorful log
            console.log('%c=== SSE Flow: msgHistory ===', 'color: green', this.msgHistory);
            // if (this.msgHistory.length === 2) {
            //   this.saveChatToStorage({
            //     title: this.msgHistory[0].msg,
            //     messages: this.msgHistory,
            //     isAnonymous: this.isAnonymous,
            //   });
            // }

            // Use requestAnimationFrame instead of 500ms setTimeout
            requestAnimationFrame(() => {
              requestAnimationFrame(() => {
                this.googleMap?.fitBounds();
              });
            });
            this.aiResTextContent = '';
            this.retryCount = 0;
            if (streamChatId) {
              this.pendingStreamByChatId.delete(streamChatId);
              const resolvedChatId = this.chatIdAliases.get(streamChatId);
              if (resolvedChatId) {
                this.pendingStreamByChatId.delete(resolvedChatId);
              }
            }
            this.activeStreamToken = null;
          } catch (ex) {
            console.error('Error in askAI:', ex);
            // this.createMsg({ type: 'AI_ERROR' } as ITravelAssistantMessage);
          } finally {
            this.cdRef.detectChanges();
          }
        }

        if (evt.type === 'error') {
          this.isWaitingForAIResponse = false;
          if (this.canRenderStreamForChat(streamChatId, streamToken)) {
            this.createMsg({ type: 'AI_ERROR' } as ITravelAssistantMessage);
          }
          if (streamChatId) {
            this.pendingStreamByChatId.delete(streamChatId);
            const resolvedChatId = this.chatIdAliases.get(streamChatId);
            if (resolvedChatId) {
              this.pendingStreamByChatId.delete(resolvedChatId);
            }
          }
          this.activeStreamToken = null;
          this.cdRef.detectChanges();
        }
      });
  }

  private canRenderStreamForChat(streamChatId: string | null, streamToken: string): boolean {
    if (this.activeStreamToken !== streamToken) return false;
    if (!this.chatContainer) return false;
    if (!streamChatId) return !this.currentChat;
    const resolvedStreamChatId = this.resolveChatId(streamChatId);
    return this.currentChat?.id === resolvedStreamChatId;
  }

  private cachePendingStream(streamChatId: string | null, fullResponse: string): void {
    if (!streamChatId) return;
    const pending = {
      fullResponse,
      hasMetadata: fullResponse.includes('<METADATA>'),
      hasToolCall: fullResponse.includes('<TOOLCALL>'),
    };
    this.pendingStreamByChatId.set(streamChatId, pending);
    const resolvedChatId = this.resolveChatId(streamChatId);
    if (resolvedChatId) {
      this.pendingStreamByChatId.set(resolvedChatId, pending);
    }
  }

  private restorePendingStreamForChat(chatId: string | undefined): void {
    if (!chatId) return;
    const pending = this.pendingStreamByChatId.get(chatId);
    if (!pending?.fullResponse) return;

    if (this.msgHistory.last()?.type !== 'AI_THINKING') {
      this.createMsg({
        msg: '',
        type: 'AI_THINKING',
        questions: [],
      } as ITravelAssistantMessage);
    }

    requestAnimationFrame(() => {
      this.renderStreamResponseToView(pending.fullResponse);
    });
  }

  private appendAiMessageToChat(
    streamChatId: string | null,
    message: ITravelAssistantMessage,
  ): void {
    if (!streamChatId) return;
    const resolvedChatId = this.resolveChatId(streamChatId);
    const targetChat = this.recentChats.find((chat) => chat.id === resolvedChatId);
    if (!targetChat) return;

    const messages = [...(targetChat.messages || [])];
    if (messages.last()?.type === 'AI_THINKING') {
      messages.pop();
    }

    const aiMsg = {
      ...message,
      type: 'AI' as const,
      name: this.travelBuddySettings.ui.avatar.name,
      timestamp: message.timestamp || new Date(),
      id: message.id || this.generateMessageId(),
    };

    messages.push(aiMsg);

    targetChat.messages = messages;
    targetChat.timestamp = new Date();

    // Persist so the response isn't lost on page refresh
    if (this.isAnonymous) {
      // Guest: update localStorage
      this.saveRecentChatsToLocalStorage();
    } else {
      // Logged-in: persist via API
      const userContext = this.getUserContext();
      if (userContext.userId && resolvedChatId) {
        const lastUserMsg = messages.findLast((m: any) => m.type === 'USER');
        const persistMsg = {
          ...aiMsg,
          userQuery: lastUserMsg?.msg || lastUserMsg?.userQuery,
          placeSearch: (aiMsg.placeSearch || []).map((p) =>
            typeof p === 'string' ? p : p.name,
          ),
        };
        this.travelBuddyChatService
          .updateChat(
            this.hubName,
            {
              chatId: resolvedChatId,
              title: targetChat.title,
              messages: [persistMsg],
              isInsert: true,
              metadata: { lastMessageAt: new Date().toISOString() },
            },
            userContext,
          )
          .subscribe({
            next: () => {
              console.log('Background stream response persisted for chat:', resolvedChatId);
              this.assignChatToFolder();
            },
            error: (err) =>
              console.error('Failed to persist background stream response:', err),
          });
      }
    }
  }

  private normalizeSuggestedPrompts(questions: string[]): string[] {
    return (questions || [])
      .slice(0, 2)
      .map((q) => {
        let cleaned = q.replace(/^[",\s]+|[",\s]+$/g, '');
        cleaned = cleaned.replace(/^"(.*)"$/, '$1');
        if (cleaned.includes(`"questions":`)) {
          cleaned = cleaned.substring(cleaned.indexOf('"questions": ["') + 15);
        }
        return cleaned;
      })
      .filter((q) => q.length > 0);
  }

  private restoreSuggestedPromptsForChat(chatId: string | undefined): void {
    const resolvedChatId = this.resolveChatId(chatId);
    const cachedPrompts = resolvedChatId ? this.suggestedPromptsByChatId.get(resolvedChatId) : null;
    if (cachedPrompts?.length) {
      this.suggestedPrompts = [...cachedPrompts];
      return;
    }

    const lastAiMsg = [...(this.msgHistory || [])]
      .reverse()
      .find((m) => m.type === 'AI' && m.questions);
    this.suggestedPrompts = this.normalizeSuggestedPrompts(lastAiMsg?.questions || []);
  }

  private resolveChatId(chatId: string | null | undefined): string | undefined {
    if (!chatId) return undefined;
    return this.chatIdAliases.get(chatId) || chatId;
  }

  private renderStreamResponseToView(fullResponse: string): void {
    const msgEle = this.chatContainer?.nativeElement?.querySelectorAll('ig-msg-box .ig-im-answer');
    const msgBox = Array.from(msgEle as HTMLElement[]).last();
    if (!msgBox) return;

    if (fullResponse.includes('<TOOLCALL>')) {
      msgBox.innerHTML = fullResponse.replace('<TOOLCALL>', '');
      this.scrollToBottom(0);
      this.cdRef.detectChanges();
      return;
    }

    if (fullResponse.includes('<METADATA>')) {
      this.isMappingData = true;
      const metadataIndex = fullResponse.indexOf('<METADATA>');
      const answerBeforeMetadata = fullResponse.substring(0, metadataIndex).trim();
      const marked = this.processMsg({
        answer: answerBeforeMetadata,
      } as IAIResponse);
      msgBox.innerHTML = `${marked.answer}<br>
              <div class="text-sm italic text-gray-500">Loading details...</div>
              <div class="ig-loading-dot">
                <div class="ig-loading-dot-wrap">
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
              </div>`;
      this.scrollToBottom(0);
      this.cdRef.detectChanges();
      return;
    }

    const marked = this.processMsg({ answer: fullResponse } as IAIResponse);
    msgBox.innerHTML = marked.answer.replaceAll('<a', '<a target="_blank"');
    this.scrollToBottom(0);
    this.cdRef.detectChanges();
  }

  private retry(): void {
    const lastUserMsg = this.msgHistory?.filter((x) => x.type === 'USER')?.last()?.msg;
    if (!lastUserMsg || this.isWaitingForAIResponse) return;

    this.msg = lastUserMsg;

    // ensure there is an AI_THINKING indicator during retry
    if (this.msgHistory.last()?.type !== 'AI_THINKING') {
      this.createMsg({
        msg: '',
        type: 'AI_THINKING',
        questions: [],
      } as ITravelAssistantMessage);
    }

    this.askAI(false);
  }

  // Add this to your component class
  favoritePlaces: any[] = []; // This will store favorite places
  isLoadingFavorites: boolean = false;

  // Toggle favorite status for a place
  toggleFavorite(item: any) {
    const userContext = this.getUserContext();
    if (!userContext.userId) {
      this.showError('You must be logged in to save favorites');
      return;
    }

    const isEvent = !!item.startTime;
    const snapshot = isEvent
      ? {
          cover: item.cover,
          startTime: item.startTime,
          endTime: item.endTime,
          timeOneLine: item.timeOneLine,
        }
      : {
          cover: item.cover,
          category: item.category,
        };

    const subscription = this.travelBuddyChatService
      .toggleFavorite({
        hubName: this.hubName,
        userId: userContext.userId,
        itemObjectId: item._id,
        type: item.startTime ? 'EVENT' : 'PLACE',
        name: item.name,
        alias: item.alias,
        snapshot: JSON.stringify(snapshot),
        googlePlaceId: isEvent ? null : item.id,
      })
      .subscribe({
        next: (response) => {
          // Update local state based on the response
          const index = this.favoritePlaces.findIndex((p) => p._id === item._id);
          if (response.isFavorited) {
            if (index === -1) {
              this.favoritePlaces.push({ ...item, isFavorite: true });

              this.flashFavPanel();
              this.flashExpandButton();
            }
          } else {
            if (index !== -1) {
              this.favoritePlaces.splice(index, 1);
            }
          }
          this.cdRef.detectChanges();
        },
        error: (error) => {
          console.error('Error toggling favorite:', error);
          // Show error message to user if needed
          this._snackBar.open('Failed to update favorites', 'Dismiss', {
            duration: 3000,
            panelClass: ['error-snackbar'],
          });
        },
        complete: () => {
          subscription.unsubscribe();
        },
      });
  }

  isFavorite(place: any) {
    return this.favoritePlaces.some((p) => p._id === place._id);
  }

  loadUserFavorites() {
    if (this.isLoadingFavorites) return;

    // Only proceed if we have a valid user ID and hub name
    const context = this.getUserContext();
    if (!context || !context.userId) {
      console.warn('Cannot load favorites: Missing user ID or hub name');
      return;
    }

    // Set loading state
    this.isLoadingFavorites = true;

    // Call the service to get user favorites
    const subscription = this.travelBuddyChatService
      .getUserFavorites(this.hubName, context.userId)
      .subscribe({
        next: (response: any) => {
          if (response?.success) {
            this.favoritePlaces = [];
            // Update the favorites array with the response data
            const favorites = response.data || [];
            for (const favorite of favorites) {
              const snapshot = favorite.snapshot ? JSON.parse(favorite.snapshot) : null;
              this.favoritePlaces.push({
                _id: favorite.itemObjectId,
                name: favorite.name,
                alias: favorite.alias,
                id: favorite.googlePlaceId,
                cover: snapshot?.cover,
                category: snapshot?.category,
                startTime: snapshot?.startTime,
                endTime: snapshot?.endTime,
                isFavorite: true,
              });
            }
            console.log('%cFavorites loaded:', 'color: pink', this.favoritePlaces);
          }
        },
        error: (error) => {
          console.error('Error loading favorites:', error);
          // Show error message to user
          this._snackBar.open('Failed to load favorites', 'Dismiss', {
            duration: 3000,
            panelClass: ['error-snackbar'],
          });
        },
        complete: () => {
          this.isLoadingFavorites = false;
          subscription.unsubscribe();
        },
      });
  }

  flashFavPanel() {
    setTimeout(() => {
      // Add flash effect to the favorites panel
      const panel = this.favList?.nativeElement?.querySelector('.mat-expansion-panel');
      if (panel) {
        // Store original background color
        const originalBg = window.getComputedStyle(panel).backgroundColor;

        // Add flash class for animation
        panel.classList.add('favorite-flash');

        // Remove the class after animation completes
        setTimeout(() => {
          if (panel) {
            panel.classList.remove('favorite-flash');
            (panel as HTMLElement).style.backgroundColor = originalBg; // Reset to original
          }
        }, 1000); // Match this with CSS animation duration
      }
    });
  }

  flashExpandButton() {
    setTimeout(() => {
      const btn = this.expandBtn?.nativeElement;
      if (!btn) return;

      // Remove any existing animation classes
      btn.classList.remove('expand-btn-flash');

      // Trigger reflow to ensure the animation can be replayed
      void btn.offsetWidth;

      // Add the animation class
      btn.classList.add('expand-btn-flash');

      // Remove the class after animation completes
      setTimeout(() => {
        btn.classList.remove('expand-btn-flash');
      }, 1000);
    });
  }

  flashSavedTripPanel() {
    setTimeout(() => {
      // Add flash effect to the saved trips panel
      const panel = this.aiTripList?.nativeElement?.querySelector('.mat-expansion-panel');
      if (panel) {
        // Store original background color
        const originalBg = window.getComputedStyle(panel).backgroundColor;

        // Add flash class for animation
        panel.classList.add('favorite-flash');

        // Remove the class after animation completes
        setTimeout(() => {
          if (panel) {
            panel.classList.remove('favorite-flash');
            (panel as HTMLElement).style.backgroundColor = originalBg; // Reset to original
          }
        }, 1000); // Match this with CSS animation duration
      }
    });
  }

  removeFavorite(place: any) {
    this.toggleFavorite(place);
  }

  generateUserId() {
    if (!this.anonymousUserId) {
      this.anonymousUserId =
        Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
    }
    return this.anonymousUserId;
  }

  createGPTMsg(response) {
    const data = JSON.parse(response.data);
    this.createMsg({
      msg: data.answer,
      type: 'AI',
      model: response.model,
      questions: ['Please tell more', ...data.questions],
    } as ITravelAssistantMessage);
  }

  processMsg(response: IAIResponse): IAIResponse {
    if (response.answer) {
      let cleanedAnswer = response.answer;

      // IMPORTANT: Remove metadata BEFORE markdown conversion to prevent HTML tag issues

      // Check if <METADATA> appears and handle accordingly
      const metadataIndex = cleanedAnswer.indexOf('<METADATA>');

      if (metadataIndex !== -1) {
        // If <METADATA> is at the start (first in response), keep only the part after metadata
        if (metadataIndex === 0 || metadataIndex < 50) {
          // Find the end of metadata block
          const metadataEndWithTag = cleanedAnswer.indexOf('</METADATA>');
          const metadataEndWithBrace = this.findClosingBrace(cleanedAnswer, metadataIndex);

          if (metadataEndWithTag !== -1) {
            // Has closing tag, take everything after it
            cleanedAnswer = cleanedAnswer
              .substring(metadataEndWithTag + '</METADATA>'.length)
              .trim();
          } else if (metadataEndWithBrace !== -1) {
            // Has closing brace, take everything after it
            cleanedAnswer = cleanedAnswer.substring(metadataEndWithBrace + 1).trim();
          } else {
            // No clear end, remove from <METADATA> onward
            cleanedAnswer = cleanedAnswer.substring(0, metadataIndex).trim();
          }
        } else {
          // <METADATA> appears later in the text, remove it and everything after
          cleanedAnswer = cleanedAnswer.substring(0, metadataIndex).trim();
        }
      }

      // Additional cleanup: Remove any remaining <METADATA> blocks
      cleanedAnswer = cleanedAnswer.replace(/<METADATA>[\s\S]*?<\/METADATA>/gi, '');
      cleanedAnswer = cleanedAnswer.replace(/<METADATA>[\s\S]*$/gi, '');

      // Remove any line that contains <METADATA>
      cleanedAnswer = cleanedAnswer.replace(/^.*<METADATA>.*$/gm, '');
      cleanedAnswer = cleanedAnswer.replace(/^.*<\/METADATA>.*$/gm, '');

      // Remove any standalone JSON objects (lines containing placesMentioned, eventsMentioned, etc.)
      cleanedAnswer = cleanedAnswer.replace(/^\s*\{[\s\S]*?"placesMentioned"[\s\S]*?\}\s*$/gm, '');

      // Remove individual JSON properties that might leak through
      cleanedAnswer = cleanedAnswer.replace(/"placesMentioned"\s*:\s*\[[\s\S]*?\]/g, '');
      cleanedAnswer = cleanedAnswer.replace(/"eventsMentioned"\s*:\s*\[[\s\S]*?\]/g, '');
      cleanedAnswer = cleanedAnswer.replace(/"askForEvents"\s*:\s*(true|false)/g, '');
      cleanedAnswer = cleanedAnswer.replace(/"askForItinerary"\s*:\s*(true|false)/g, '');
      cleanedAnswer = cleanedAnswer.replace(/"questions"\s*:\s*\[[\s\S]*?\]/g, '');

      // Clean up artifacts
      cleanedAnswer = cleanedAnswer.replace(/,\s*,/g, ',');
      cleanedAnswer = cleanedAnswer.replace(/,\s*\}/g, '}');
      cleanedAnswer = cleanedAnswer.replace(/\{\s*,/g, '{');
      cleanedAnswer = cleanedAnswer.replace(/^\s*[\{\}\[\]]\s*$/gm, ''); // Remove lines with only brackets
      cleanedAnswer = cleanedAnswer.replace(/\n{3,}/g, '\n\n'); // Remove excessive blank lines

      response.answer = cleanedAnswer.trim();

      // Convert markdown to HTML AFTER cleaning
      if (window['marked']) {
        response.answer = window['marked']
          .parse(response.answer)
          .replaceAll('<a', '<a target="_blank"')
          .replaceAll('**', '');
      }

      response.answer = this.boldNamesInHtml(response.answer, response.placesMentioned);
      response.answer = this.boldNamesInHtml(response.answer, response.eventsMentioned);
    }
    return response;
  }

  boldNamesInHtml(html: string, items: { name: string; city: string }[]) {
    if (!html || !items?.length) return html;

    const names = items
      .map((i) => i.name)
      .filter(Boolean)
      .sort((a, b) => b.length - a.length)
      .map(this.escapeRegExp);

    if (!names.length) return html;

    const nameRegex = new RegExp(`(${names.join('|')})`, 'g');

    return html.replace(nameRegex, (match, name, offset) => {
      const before = html.slice(0, offset);
      const lastOpen = before.lastIndexOf('<strong>');
      const lastClose = before.lastIndexOf('</strong>');

      const isAlreadyBold = lastOpen !== -1 && lastOpen > lastClose;

      return isAlreadyBold ? match : `<strong>${match}</strong>`;
    });
  }

  escapeRegExp(str: string) {
    return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  createErrorMsg(response) {
    this.createMsg({
      msg: response.model + ` didn't respond correctly`,
      type: 'AI',
      model: response.model,
    } as ITravelAssistantMessage);
  }

  askDelete(chatId: string) {
    this.deletingChatId = chatId;
    this.isDeleting = true;
  }

  removeLastOccurrence(str, substring) {
    const lastIndex = str.lastIndexOf(substring);

    if (lastIndex !== -1) {
      return str.slice(0, lastIndex) + str.slice(lastIndex + substring.length);
    }

    return str;
  }

  // Helper method to find the closing brace for a JSON object
  private findClosingBrace(text: string, startIndex: number): number {
    const openBraceIndex = text.indexOf('{', startIndex);
    if (openBraceIndex === -1) return -1;

    let depth = 0;
    for (let i = openBraceIndex; i < text.length; i++) {
      if (text[i] === '{') depth++;
      if (text[i] === '}') {
        depth--;
        if (depth === 0) return i;
      }
    }
    return -1; // No matching closing brace found
  }

  anonymousUse() {
    this.isShowLogin = false;
    this.isAppendLoginToChatArea = false;
    this.isAnonymous = true;
    this._localStorage.setItem('travelbuddy_is_anonmous_use', true);
    console.log('anonymous use -----------');
    // this.send(true);
  }

  get isUserLoggedIn() {
    return this.userFromStorage ? true : false;
  }

  // isUserLoggedIn: boolean = false;
  loginStatusChanged(status: boolean) {
    console.log('-------------------------------------------------- login status', status);
    this.userProfilePicture = this.userFromStorage?.avatar || '';
    this.emailErrorMsg = '';
    this.isMapOpen = false;

    // status is for Google or FB login status, isUserLoggedIn is for email login
    if (status || this.isUserLoggedIn) {
      this.isSidebarCollapsed = this.isMobile ? true : false;
      this.isAppendLoginToChatArea = false;
    }

    if (this.isUserLoggedIn) {
      this.loadUserFavorites();
      this.loadUserSavedAITrips();
      this.updateUserInfo();

      this.continuePendingTripCopyAfterLogin();
    } else {
      this.selectedAITrip = null;
      this.savedAITrips = null;
      this.favoritePlaces = [];
      this.closeDetailsPanel();
      this.preserveRecentChatsForGuestMode();
      this.isAnonymous = true;
      this.userChatFolders = [];
      this.msgHistory = [];
      this.isShowLandscreen = true;
      this.currentChat = null;
      this.loadRecentChatsFromLocalStorage();
    }
  }

  accordionClick(event) {
    this.cdRef.detectChanges();
  }

  private preserveRecentChatsForGuestMode() {
    if (this.guestChatStorage.hasGuestChats() || !this.recentChats?.length) {
      return;
    }

    this.guestChatStorage.saveGuestChats(
      this.recentChats.map((chat) => ({
        id: chat.id,
        title: chat.title || 'Untitled chat',
        messages: chat.messages || [],
        timestamp: chat.timestamp || new Date(),
        pinned: chat.pinned,
        pinnedAt: chat.pinnedAt,
        metadata: chat.metadata,
        transferred: true,
      })),
    );
  }

  private readonly emptyMatchedPlaces = [];
  private readonly approvedMatchedPlacesCache = new WeakMap<
    object,
    { source: any[]; result: any[] }
  >();

  getAvailableMatchedPlaces(msg) {
    const source = msg?.placesMatched;
    if (!source?.length) {
      return this.emptyMatchedPlaces;
    }

    const cached = this.approvedMatchedPlacesCache.get(msg);
    if (cached?.source === source) {
      return cached.result;
    }

    const seenNames = new Set<string>();
    const result = source.filter((x) => {
      // for searched places, they don't have isApproved field
      if (x.isApproved === false) {
        return false;
      }

      const normalizedName = (x.name || '').trim().toLowerCase();
      if (!normalizedName) {
        return true;
      }

      if (seenNames.has(normalizedName)) {
        return false;
      }

      seenNames.add(normalizedName);
      return true;
    });
    this.approvedMatchedPlacesCache.set(msg, { source, result });
    return result;
  }

  resetRecentChats() {
    // Reset chat state
    this.msgHistory = [];
    this.isShowLandscreen = true;
    this.isInNormalChat = false;
    this.isAIRespond = false;
    this.isFolding = false;

    // Reset recent chats
    this.recentChats = [];
    this.currentChatTitle = '';
    this.currentChatDate = new Date();

    this.savedAITrips = null;
  }

  logout() {
    // Use setTimeout to allow menu to close before opening modal (improves perceived performance)
    setTimeout(() => {
      try {
        console.log('Logging out user...');

        this.preserveRecentChatsForGuestMode();

        this._localStorage.removeItem('travelbuddy_user_email');
        this._localStorage.removeItem('social.login.googleUser');
        this._localStorage.removeItem('social.login.facebookUser');

        // Clear user profile data
        this.userProfilePicture = undefined;
        this.userEmail = undefined;
        this.isAnonymous = true;
        this.userChatFolders = [];

        // Set user as anonymous guest
        this._localStorage.setItem('travelbuddy_is_anonmous_use', true);

        // Clear social login data
        if (this.socialLogin) {
          this.socialLogin.logout();
        }

        // Reset social login status
        SocialLoginComponent.loginStatus$.next(false);

        // Clear session data
        this.threadId = undefined;
        this.assistantId = undefined;

        // Reset map state
        this.resetMapState();

        // Reset login status
        this.loginStatusChanged(false);

        console.log('User logged out successfully - reloading page to reset all state');

        // Reload page to ensure all state is reset and login option appears
        // setTimeout(() => {
        //   window.location.reload();
        // }, 0);
      } catch (error) {
        console.error('Error during logout:', error);
        this._snackBar.open('Error during logout. Please try again.', 'Close', {
          duration: 3000,
          horizontalPosition: 'center',
          verticalPosition: 'bottom',
        });
      }
    }, 0);
  }

  backToLandScreen() {
    this.isShowLandscreen = true;
    this.hasChatViewShowed = true;
  }

  isImg(url: string) {
    if (!url) return false;
    return url.match(/\.(jpeg|jpg|gif|png|webp)$/) != null;
  }

  // Route drawing methods
  drawDirectionRoute() {
    // Create direction locations from matched places and events
    this.directionLocations = [];

    // Add places to direction locations
    this.currentMsgForMap?.placesMatched?.forEach((place, index) => {
      this.directionLocations.push({
        id: place._id,
        name: place.name,
        address:
          typeof place.address === 'string'
            ? place.address
            : place.address?.address || 'Address not available',
        lat: place.lat || place.address?.lat,
        lng: place.lng || place.address?.lng,
        stopover: true,
      });
    });

    // Add events to direction locations
    this.currentMsgForMap?.eventsMatched?.forEach((event, index) => {
      this.directionLocations.push({
        id: event._id,
        name: event.title,
        address:
          typeof event.address === 'string'
            ? event.address
            : event.address?.address || 'Address not available',
        lat: event.lat || event.address?.lat,
        lng: event.lng || event.address?.lng,
        stopover: true,
      });
    });

    // Only proceed if we have at least 2 locations for a route
    if (this.directionLocations.length < 2) {
      console.log('Not enough locations to draw a route. Need at least 2 locations.');
      return;
    }

    // Clear existing markers and create new ones for the route
    this.welcomePageMapMarkers = [];

    try {
      console.log('--- welcomePageMapMarkers 1');
      this.directionLocations.forEach((location, index) => {
        this.welcomePageMapMarkers.push({
          position: new google.maps.LatLng(location.lat, location.lng),
          label: {
            text: (index + 1).toString(),
            fontWeight: 'bold',
          },
          title: location.name,
          data: location,
        } as any);
      });

      // Draw the route on the map
      this.googleMap?.drawDirectionRoute(this.directionLocations);
      this.directionType = 'normal';
    } catch (ex) {
      console.error('Error drawing direction route:', ex);
    }
  }

  optimizeDirectionRouteByDistance() {
    if (this.directionLocations.length <= 1) return;

    const start = this.directionLocations[0];
    let waypoints = [start];

    // Find nearest points in sequence
    while (waypoints.length < this.directionLocations.length) {
      const point = waypoints[waypoints.length - 1];
      const nearest = this.getNearestPoint(
        point,
        this.directionLocations.filter((x) => x !== point && !waypoints.includes(x)),
      );
      if (nearest) {
        waypoints.push(nearest);
      } else {
        break;
      }
    }

    // Update direction locations with optimized order
    this.directionLocations = waypoints;

    // Redraw route with optimized waypoints
    this.googleMap?.drawDirectionRoute(waypoints);

    // Update markers
    this.welcomePageMapMarkers = [];
    console.log('--- welcomePageMapMarkers 2');
    waypoints.forEach((location, index) => {
      this.welcomePageMapMarkers.push({
        position: new google.maps.LatLng(location.lat, location.lng),
        label: {
          text: (index + 1).toString(),
          fontWeight: 'bold',
        },
        title: location.name,
        data: location,
      } as any);
    });

    this.directionType = 'optimized';
  }

  getNearestPoint(start: any, targetPoints: any[]): any {
    let minDistance = 99999;
    let nearestPoint = null;

    for (const point of targetPoints) {
      const distance = this.getDistanceFromLatLng(start.lat, start.lng, point.lat, point.lng);
      if (distance < minDistance && distance > 0) {
        minDistance = distance;
        nearestPoint = point;
      }
    }

    return nearestPoint;
  }

  getDistanceFromLatLng(lat1: number, lng1: number, lat2: number, lng2: number): number {
    const R = 6371; // Radius of the Earth in kilometers
    const dLat = this.deg2rad(lat2 - lat1);
    const dLng = this.deg2rad(lng2 - lng1);
    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(this.deg2rad(lat1)) *
        Math.cos(this.deg2rad(lat2)) *
        Math.sin(dLng / 2) *
        Math.sin(dLng / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const distance = R * c; // Distance in kilometers
    return distance;
  }

  deg2rad(deg: number): number {
    return deg * (Math.PI / 180);
  }

  getDirections() {
    if (this.directionLocations.length === 0) return;

    const addresses = this.directionLocations.map((stop) =>
      String(stop.address || '')
        .replace(/,?\s*null\b/gi, '')
        .trim(),
    );

    const destination = addresses[addresses.length - 1];
    const intermediateWaypoints = addresses.slice(0, -1);

    let url = 'https://www.google.com/maps/dir/?api=1';
    url += `&destination=${encodeURIComponent(destination)}`;
    if (intermediateWaypoints.length > 0) {
      url += `&waypoints=${encodeURIComponent(intermediateWaypoints.join('|'))}`;
    }
    url += '&travelmode=driving';

    const ua = navigator.userAgent;

    const isIOSWebView =
      /iPad|iPhone|iPod/.test(ua) &&
      /AppleWebKit/.test(ua) &&
      !/Safari\//.test(ua);

    const isAndroidWebView = /Android/.test(ua) && /\bwv\b/.test(ua);

    if (isIOSWebView || isAndroidWebView) {
      window.location.href = url;
    } else {
      const a = document.createElement('a');
      a.href = url;
      a.target = '_blank';
      a.rel = 'noopener noreferrer';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    }
  }

  // New methods for avatar functionality
  showLoginPopup() {
    console.log('showLoginPopup called');
    this.lastLoginTriggerElement = this.getActiveElement();
    this.isShowLoginPopup = true;

    // Trigger change detection to ensure DOM is updated
    this.cdRef.detectChanges();
    this.focusFirstElementInDialog(this.loginDialog?.nativeElement);

    // Initialize Google login and render button after DOM is ready
    setTimeout(() => {
      console.log('Initializing Google login in popup...');

      const container = this._document.querySelector('#ig-ai-buddy')?.shadowRoot;
      this.checkLoginStatusService.renderGoogleButtons(container);

      // Ensure Google is initialized
      if (this.googleLogin) {
        console.log('Google login component found, calling initializeGoogle');
        this.googleLogin.initializeGoogle();
      } else {
        console.log('Google login component not found, using service');
        this.checkLoginStatusService
          .initializeGoogle()
          .then(() => {
            console.log('CheckLoginStatusService Google initialization completed');
          })
          .catch((error) => {
            console.error('CheckLoginStatusService Google initialization failed:', error);
          });
      }

      // Render button directly using ViewChild reference
      setTimeout(() => {
        if (this.googlePopupContainer && this.googleLogin) {
          console.log('Rendering Google button using ViewChild element reference');
          this.googleLogin.renderButtonInElement(this.googlePopupContainer.nativeElement);
        } else {
          console.warn('Google popup container or login component not available', {
            container: !!this.googlePopupContainer,
            googleLogin: !!this.googleLogin,
          });
          // Fallback to old method
          this.forceRenderGoogleButtons();
        }
      }, 500);
    }, 200);
  }

  private forceRenderGoogleButtons() {
    console.log('Force rendering Google buttons in popup...');

    // Trigger change detection before rendering
    this.cdRef.detectChanges();

    // Ensure Google is initialized first
    const google = (window as any).google;
    if (!google?.accounts?.id) {
      console.log('Google Sign-In not loaded yet, waiting...');
      setTimeout(() => {
        this.forceRenderGoogleButtons();
      }, 500);
      return;
    }

    // Try to render Google button in the popup container using the specific ID
    const popupContainer = document.querySelector('#google-signin-btn-popup');
    if (popupContainer && !popupContainer.querySelector('.abcRioButton')) {
      if (google.accounts.id.renderButton) {
        try {
          console.log('Rendering Google button in popup container:', popupContainer);
          google.accounts.id.renderButton(popupContainer, {
            type: 'standard',
            theme: 'outline',
            size: 'large',
            width: 295,
          });
        } catch (error) {
          console.error('Failed to render Google button in popup:', error);
        }
      }
    } else if (popupContainer?.querySelector('.abcRioButton')) {
      console.log('Google button already rendered in popup');
    } else {
      console.log('No popup container found for Google button');
    }
  }

  private checkGoogleButtonRendered() {
    const googleButton = document.querySelector('#google-signin-btn-popup .abcRioButton');
    if (googleButton) {
      console.log('Google button successfully rendered in popup');
    } else {
      console.log('Google button not rendered in popup, fallback button should be visible');
    }
  }

  closeLoginPopup(restoreFocus = true) {
    console.log('closeLoginPopup called');
    this.isShowLoginPopup = false;
    this.emailInput = '';
    this.emailErrorMsg = '';
    if (restoreFocus) {
      this.restoreFocus(this.lastLoginTriggerElement);
    }
  }

  getUserDisplayName(): string {
    if (this.isUserLoggedIn) {
      return this.userFromStorage?.userName || '';
    }
    return 'Guest';
  }

  continueAsGuest() {
    this.closeLoginPopup();
    this.pendingTripCopyAfterLogin = null;
    this.anonymousUse();

    // If there's a pending message, send it now that user is anonymous
    // if (this.msg && this.msg.trim()) {
    //   console.log('Sending pending message as guest:', this.msg);
    //   this.send(false);
    // }
  }

  onLoginStatusChanged(status: boolean) {
    console.log('onLoginStatusChanged called with status:', status);
    this.loginStatusChanged(status);
    if (status) {
      console.log('Login successful, closing popup and updating user info');
      this.closeLoginPopup();

      if (this.msg && this.msg.trim() && !this.isTransferringGuestChats) {
        console.log('Sending pending message after login:', this.msg);
        this.send(false);
      }
    }
  }

  private checkAndUpdateUserStatus() {
    // Check if user is already logged in via social login
    if (SocialLoginComponent.isUserLoggedIn) {
      console.log('User already logged in, updating UI');
      this.updateUserInfo();
    }
  }

  private updateUserInfo() {
    // Update user profile picture from social login
    this.userProfilePicture = this.userFromStorage?.avatar || '';

    const userId = this.userFromStorage?.userId;

    if (userId && !this.isTransferringGuestChats && this.guestChatStorage.hasUntransferredGuestChats()) {
      this.isTransferringGuestChats = true;
      this.guestTransferStartTime = Date.now();

      this.flushCurrentGuestChatToLocalStorage();
      this.isAnonymous = false;

      console.log('Copying guest chats to user account (keeping local guest list)');
      this.guestChatStorage.transferToUserAccount(this.hubName, userId).subscribe({
        next: (result) => {
          this.isTransferringGuestChats = false;
          console.log('Guest chats transferred successfully:', result.transferredCount);
          this.loadRecentChatsFromUserAccount();
          if (this.msg && this.msg.trim()) {
            this.send(false);
          }
          this.cdRef.detectChanges();
        },
        error: (error) => {
          this.isTransferringGuestChats = false;
          console.error('Failed to transfer guest chats:', error);
          this.loadRecentChatsFromUserAccount();
          this.cdRef.detectChanges();
        },
      });
    } else if (!this.isTransferringGuestChats) {
      this.isAnonymous = false;
      // No guest chats to transfer, just load user chats from API
      console.log('No guest chats to transfer, loading user chats from API');
      this.loadRecentChatsFromUserAccount();
      this.cdRef.detectChanges();
    }

    console.log('Updated user info:', {
      isUserLoggedIn: this.isUserLoggedIn,
      userProfilePicture: this.userProfilePicture,
      userEmail: this.userEmail,
      displayName: this.getUserDisplayName(),
    });
  }

  private flushCurrentGuestChatToLocalStorage() {
    if (this.currentChat) {
      const resolvedId = this.resolveChatId(this.currentChat.id);
      const chatIndex = this.recentChats.findIndex(
        (c) => c.id === this.currentChat.id || c.id === resolvedId,
      );
      if (chatIndex >= 0) {
        this.recentChats[chatIndex].messages = [...this.msgHistory];
        this.recentChats[chatIndex].timestamp = new Date();
        this.currentChat = this.recentChats[chatIndex];
      }
    }
    this.saveRecentChatsToLocalStorage();
  }

  getUserEmail(): string {
    // Check social login first
    if (SocialLoginComponent.isUserLoggedIn) {
      const email = SocialLoginComponent.email;
      if (email && email.trim()) {
        return email;
      }
    }

    // Fallback to stored email
    if (this.userEmail && this.userEmail.trim()) {
      return this.userEmail;
    }

    return '';
  }

  requestGoogleLogin() {
    console.log('requestGoogleLogin called');

    // Try to trigger Google login through the component
    if (this.googleLogin) {
      console.log('Using Google login component');
      this.googleLogin.login();
    } else {
      console.log('Google login component not available, trying direct button click');

      // Try to find and click existing Google button in popup
      const popupButton = document.querySelector(
        '#google-signin-btn-popup .abcRioButton',
      ) as HTMLElement;
      if (popupButton) {
        console.log('Clicking existing Google button in popup');
        popupButton.click();
      } else {
        console.log('No existing Google button found, trying to render one');
        // Try to render button and click it
        const popupContainer = document.querySelector('#google-signin-btn-popup');
        if (popupContainer) {
          const google = (window as any).google;
          if (google?.accounts?.id?.renderButton) {
            try {
              console.log('Rendering Google button in popup');
              google.accounts.id.renderButton(popupContainer, {
                type: 'standard',
                theme: 'outline',
                size: 'large',
                width: 295,
              });
              setTimeout(() => {
                const newButton = popupContainer.querySelector('.abcRioButton') as HTMLElement;
                if (newButton) {
                  console.log('Clicking newly rendered Google button');
                  newButton.click();
                } else {
                  console.log('Failed to render Google button');
                  this._snackBar.open(
                    'Google login is not available. Please try again later.',
                    'Close',
                    {
                      duration: 3000,
                      horizontalPosition: 'center',
                      verticalPosition: 'bottom',
                    },
                  );
                }
              }, 200);
            } catch (error) {
              console.error('Failed to render Google button:', error);
              this._snackBar.open(
                'Google login is not available. Please try again later.',
                'Close',
                {
                  duration: 3000,
                  horizontalPosition: 'center',
                  verticalPosition: 'bottom',
                },
              );
            }
          } else {
            console.log('Google Sign-In library not available');
            this._snackBar.open('Google login is not available. Please try again later.', 'Close', {
              duration: 3000,
              horizontalPosition: 'center',
              verticalPosition: 'bottom',
            });
          }
        } else {
          console.log('No popup container found');
          this._snackBar.open('Google login is not available. Please try again later.', 'Close', {
            duration: 3000,
            horizontalPosition: 'center',
            verticalPosition: 'bottom',
          });
        }
      }
    }
  }

  async loadUserSavedAITrips() {
    const context = this.getUserContext();
    if (!context || !context.userId) {
      console.warn('Cannot load favorites: Missing user ID or hub name');
      return;
    }
    const trips = await this._visitorService.getUserTripsV3(this.hubName, context.userId, 'tb');
    console.log('User trips loaded:', trips);
    this.savedAITrips = trips;
    this.cdRef.detectChanges();
  }

  selectedAITrip: any;
  selectAITrip(trip: any) {
    this.closeDetailsPanel();
    this.selectedAITrip = trip;
    this.isDetailsOpen = true;
    this.isShowFeaturedPlaces = false;
    if (this.isMobile) {
      this.isSidebarCollapsed = true;
    }
  }

  private openSharedTripInOverlay(trip: any): void {
    this.lastSharedTripTriggerElement = this.getActiveElement();
    this.closeDetailsPanel();
    this.isMapOpen = false;
    this.sharedTripModalTrip = trip;
    this.isSharedTripModalOpen = true;
    this.cdRef.detectChanges();
    this.focusFirstElementInDialog(this.sharedTripDialog?.nativeElement);
  }

  closeSharedTripOverlay(restoreFocus = true): void {
    this.isSharedTripModalOpen = false;
    this.sharedTripModalTrip = null;
    this.cdRef.detectChanges();
    if (restoreFocus) {
      this.restoreFocus(this.lastSharedTripTriggerElement);
    }
  }

  /**
   * Get user context for API calls
   * Returns userId for logged-in users only (no IP tracking for guests)
   */
  private getUserContext(): { userId?: string; ipAddress?: string; isAnonymous: boolean } {
    if (this.userFromStorage) {
      this.isAnonymous = false;
      return {
        userId: this.userFromStorage.userId,
        isAnonymous: false,
      };
    } else {
      // For anonymous users, don't provide IP address or userId
      // This will prevent chat persistence for guests
      return {
        isAnonymous: true,
      };
    }
  }

  openVisitorGuide() {
    window.open(
      this.frontendSettings.customSettings.ai.travelBuddy.ui.otherInfo.visitorGuideLink,
      '_blank',
    );
  }

  async onViewSharedTripClick() {
    if (!this.sharedUserTripId || !this.sharedSingleTripId || this.isLoadingSharedTrip) {
      return;
    }

    this.isLoadingSharedTrip = true;
    try {
      const trip = await this._visitorService.getUserSingleTripsV3(
        this.hubName,
        this.sharedUserTripId,
        this.sharedSingleTripId,
      );
      if (!trip) {
        this._snackBar.open('Shared trip not found.', 'Close', {
          duration: 3000,
          horizontalPosition: 'center',
          verticalPosition: 'bottom',
        });
        return;
      }

      this.canEditTrip = false;
      this.openSharedTripInOverlay(trip);
      this.isShowSharedTripPrompt = false;
    } catch (error) {
      console.error('Failed to load shared trip:', error);
      this._snackBar.open('Failed to load shared trip. Please try again.', 'Close', {
        duration: 3000,
        horizontalPosition: 'center',
        verticalPosition: 'bottom',
      });
    } finally {
      this.isLoadingSharedTrip = false;
    }
  }

  closeSharedTripPrompt() {
    this.isShowSharedTripPrompt = false;
  }
}

const planTypes = [
  {
    type: 'Custom',
    textColor: '#878787',
    bgColor: '#e9e9e9',
    iconColor: '#c6c6c6',
    icon: 'star',
  },
  {
    type: 'Flight',
    textColor: '#b794f4',
    bgColor: '#e6e6fb',
    iconColor: '#b8b8fd',
    icon: 'flight_takeoff',
  },
  {
    type: 'Train',
    textColor: '#ff9494',
    bgColor: '#ffe4e4',
    iconColor: 'pink',
    icon: 'train',
  },
  {
    type: 'Bus',
    textColor: '#df7ffb',
    bgColor: '#f9e5ff',
    iconColor: '#f1c0ff',
    icon: 'directions_bus_filled',
  },
  {
    type: 'Subway',
    textColor: '#ff9569',
    bgColor: '#fdecd9',
    iconColor: '#ffbf8c',
    icon: 'subway',
  },
  {
    type: 'Taxi / Car',
    textColor: '#37a3ff',
    bgColor: '#cbe8ff',
    iconColor: '#aad5ff',
    icon: 'local_taxi',
  },
  {
    type: 'Visit',
    textColor: '#50a7c7',
    bgColor: '#cfe9f3',
    iconColor: '#99d7ee',
    icon: 'tour',
  },
  {
    type: 'Explore',
    textColor: '#4eb284',
    bgColor: '#daebe3',
    iconColor: '#bedacd',
    icon: 'explore',
  },
  {
    type: 'Stroll',
    textColor: '#c0823e',
    bgColor: '#ebdbca',
    iconColor: '#f3c89a',
    icon: 'directions_walk',
  },
  {
    type: 'Wander',
    textColor: '#c0823e',
    bgColor: '#ebdbca',
    iconColor: '#f3c89a',
    icon: 'directions_walk',
  },
  {
    type: 'Dine',
    textColor: '#668af5',
    bgColor: '#dbe4ff',
    iconColor: '#c3d2ff',
    icon: 'restaurant',
  },
  {
    type: 'Dining',
    textColor: '#668af5',
    bgColor: '#dbe4ff',
    iconColor: '#c3d2ff',
    icon: 'restaurant',
  },
  {
    type: 'Breakfast',
    textColor: '#02be02',
    bgColor: '#ddf5ea',
    iconColor: '#8bd78b',
    icon: 'fastfood',
  },
  {
    type: 'Lunch',
    textColor: '#db9a29',
    bgColor: '#ffe7be',
    iconColor: '#fbcb77',
    icon: 'lunch_dining',
  },
  {
    type: 'Dinner',
    textColor: '#ff8f1b',
    bgColor: '#f6eca7',
    iconColor: '#ffdf53',
    icon: 'local_dining',
  },
];
